import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {
    validationsList_template
} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template';
import {
    filterDropdown_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {filterTag_template} from "./filterTag_template";
import {filterListingPage_template} from "./filterListingPage_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {embedder_template} from "./embedder_template";
import {inclusionRules_template} from "./inclusionRules_template";
import {pinnedArticle, pinnedArticles_template} from "./pinnedArticles_template";
import {pinnedListingPages_template} from "./pinnedListingPages_template";
import {subContentArticles_template} from "./subContentArticles_template";
import {filterArticle_template} from "./filterArticle_template";
import {tagPicker_template} from "./tagPicker_template";
import {
    imagePicker_template
} from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template";
import {imageWidget_template} from "./imageWidget_template";
import {
    multipleSelector_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {EmbedInfo} from "../../utils/embeds/types";
import {videoPickerHelper} from "../../../vendor/valnet/valnet_imagePicker/js/modules/videoPickerHelper";
import videoPicker_template
    from "../../../vendor/valnet/valnet_imagePicker/js/components/templates/videoPicker_template";
import {makePermalinkFromTitle} from "../../utils/Helpers";
import {listingPagesView_template} from "./listingPagesView_template";
import {secondaryPinnedListingPages_template} from "./secondaryPinnedListingPages_template";
import {
    HubPagePinnedHubPageSection,
    HubPagePinnedHubPage,
    HubPageSearchResult,
    HubPageConfig
} from "../../utils/types/listing_page";

declare var ko: any;

export class listingPagesEdit_template extends vnTemplate {

    protected tagFilter: filterTag_template;
    public tagHubTagFilter: filterTag_template;
    public tagTypeFilter: filterAutocomplete_template;
    protected level2Filter: filterDropdown_template;
    protected typeSelector: filterDropdown_template;
    protected articleTypeSelector: filterDropdown_template;
    protected level1Filter: filterDropdown_template;
    protected specToDisplay: filterDropdown_template;
    protected validationsList: validationsList_template;
    protected tagTypeTooltip: infoButton_template
    protected level1FilterTooltip: infoButton_template
    protected level2FilterTooltip: infoButton_template
    protected specToDisplayTooltip: infoButton_template
    protected listingPageConfigTooltip: infoButton_template
    protected listingPageNoUrlTooltip: infoButton_template
    protected embedder: embedder_template
    protected listingPageInterlinkEnabledTooltip: infoButton_template;
    protected inclusionRules: inclusionRules_template;
    protected randomizePinnedArticlesTooltip: infoButton_template;
    public imagePicker: imagePicker_template;
    protected hoursPinnedTooltip: infoButton_template;
    protected tagTypeTooltipContent ;
    protected pinnedTagCardTooltipContent ;
    protected level1FilterTooltipContent ;
    protected level2FilterTooltipContent ;
    protected specToDisplayTooltipContent ;
    protected listingPageConfigTooltipContent ;
    protected listingPageNoUrlTooltipContent ;
    protected listingPageInterlinkEnabledTooltipContent;
    protected randomizePinnedArticlesTooltipContent;
    protected sortOrderTypes;
    public imageWidgetForThumbnailImage : imageWidget_template;
    public imageWidgetForAlternateImage : imageWidget_template;
    public imageWidgetForFeaturedImage : imageWidget_template;
    public pinnedArticles: pinnedArticles_template;
    public pinnedListingPages: pinnedListingPages_template;
    public secondaryPinnedListingPages: secondaryPinnedListingPages_template;
    public tagPicker: tagPicker_template;
    public filterAffiliates: filterAutocomplete_template;
    public subContentArticles :subContentArticles_template;
    public filterCategory: multipleSelector_template;
    public filterContentType: multipleSelector_template;
    public filterSegments: multipleSelector_template;
    public filterArticleCharacteristics: multipleSelector_template;
    public subContentArticlesFilter: filterArticle_template;
    public listingPagePermalinkFilter: filterListingPage_template;
    public videoPicker : videoPicker_template;
    public videoPickerHelper: videoPickerHelper;
    public channelFilter: filterAutocomplete_template;

    public tagTypesRequiresArticleSubContent: number[] = [972];

    protected getTemplateHtml(): string {

        return  /* html */`
                ${  this.validationsList.getHtmlBuild() }
                <div class="form-header">

                    <input type="hidden">

                    <!-- ko ifnot: id() -->
                    <h3 class="form-title icon i-listing-page">New Listing Page</h3>
                    <!-- /ko -->

                    <!-- ko if: id() -->
                    <h3 class="form-title icon i-listing-page" data-bind="text: name"></h3>
                    <!-- /ko -->

                    <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>

                </div>

                <div class="w-form-body no-border">

                    <div class="form-body full-width">
                        <strong class="form-sub-title">Information</strong>
                    </div>

                </div>

                <div class="w-form-body information">

                    <div class="form-body no-padding">

                        <div class="form-group">
                            <label for="name" class="form-label">Name</label>
                            <input data-bind="textInput: name, event: { focusout: () => onFocusOutListingPageName($data.name, $data.permalink) }" class="input-text"/>
                        </div>

                        <div class="form-group">
                            <label class="form-label" for="permalink">Permalink</label>
                            <div class="row link">
                                <input data-bind="textInput: permalink, css: { 'input-text': true, 'is-disable': permalinkBehavior() != '1' || listingPageConfigType() == 'homepage_video'  || listingPageConfigType() == 'homepage_thread' }"/>
                                <!-- ko if: permalinkBehavior() == '1' -->
                                <a class="btn light icon border only-icon i-link" data-bind="event: { click: viewOnWebsite}"></a>
                                <!-- /ko -->
                            </div>
                            <div class="form-group" data-bind="visible: permalinkBehavior() == '3'">
                                ${this.listingPagePermalinkFilter.getHtmlBuild()}
                            </div>

                            <div class="form-group"
                                style="margin: 1rem 0 .5rem"
                                data-bind="visible: !isHub()"
                            >
                                <div class="form-check-inline width-auto">
                                    <input type="radio" id="isResolved" name="permalink-radio-group" value="1" data-bind="checked: permalinkBehavior, attr: { 'disabled' : lockRadioPermalinks() }">
                                    <label class="form-label" for="isResolved" >Has Permalink</label>
                                </div>
                                <div class="form-check-inline width-auto">
                                    <input type="radio" id="noUrl" name="permalink-radio-group" value="2" data-bind="checked: permalinkBehavior, attr: { 'disabled' : lockRadioPermalinks() }">
                                    <label class="form-label" for="noUrl" >No Permalink</label>
                                </div>
                                <div class="form-check-inline width-auto" style="margin-left: -1rem;transform: translateY(.5rem)">
                                    <div class="w-tooltips-adv pos-top short">
                                        ${this.listingPageNoUrlTooltip.getHtmlBuild()}
                                    </div>
                                </div>
                                <div class="form-check-inline width-auto">
                                    <input type="radio" id="hubRedirectEnabled" name="permalink-radio-group" value="3" data-bind="checked: permalinkBehavior, attr: { 'disabled' : lockRadioPermalinks() }">
                                    <label class="form-label" for="hubRedirectEnabled" >Resolves to Different Hub</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="form-body no-padding">
                        <div class="form-group icon">
                            <label class="form-label" for="description">Description</label>
                            <textarea data-bind="value: description" class="input-text" style="height: 8rem;max-width: 640px;"></textarea>
                        </div>
                    </div>

                </div>

                <div class="w-form-body">

                    <div class="form-body no-padding" style="border: 0">
                        <div class="form-group">
                            <div class="form-check-inline width-auto">
                                <input type="radio"
                                    id="lp-config-articles"
                                    name="radio-group"
                                    value="articles"
                                    data-bind="
                                        checked: listingPageConfigType,
                                        disable: (isNotDeletable() && (originalListingPageConfigType() != 'tagHub' && !convertedToTagHub())) || lockRadioConfigType()
                                    "
                                >
                                <label class="form-label" for="lp-config-articles" >List of Articles</label>

                            </div>
                            <div class="form-check-inline width-auto" style="margin-left: -1rem;transform: translateY(.5rem)">
                                <div class="w-tooltips-adv pos-top short">
                                    ${this.listingPageConfigTooltip.getHtmlBuild()}
                                </div>
                            </div>
                            <div class="form-check-inline width-auto">
                                <input type="radio"
                                    id="lp-config-tags"
                                    name="radio-group"
                                    value="tags"
                                    data-bind="
                                        checked: listingPageConfigType,
                                        disable: (isNotDeletable() && (originalListingPageConfigType() != 'tagHub' && !convertedToTagHub())) || lockRadioConfigType()
                                    "
                                >
                                <label class="form-label" for="lp-config-tags" >List of Tags</label>
                            </div>
                            <div class="form-check-inline width-auto">
                                <input type="radio"
                                    id="lp-config-video"
                                    name="radio-group"
                                    value="homepage_video"
                                    data-bind="
                                        checked: listingPageConfigType,
                                        disable: (isNotDeletable() && (originalListingPageConfigType() != 'tagHub' && !convertedToTagHub())) || lockRadioConfigType()
                                    "
                                >
                                <label class="form-label" for="lp-config-video" >Video Homepage</label>
                            </div>
                            <div class="form-check-inline width-auto">
                                <input type="radio"
                                    id="lp-config-thread"
                                    name="radio-group"
                                    value="homepage_thread"
                                    data-bind="
                                        checked: listingPageConfigType,
                                        disable: (isNotDeletable() && (originalListingPageConfigType() != 'tagHub' && !convertedToTagHub())) || lockRadioConfigType()
                                    "
                                >
                                <label class="form-label" for="lp-config-thread" >Thread Homepage</label>
                            </div>
                            <div class="form-check-inline width-auto" data-bind="visible: isTagHubEnabled()">
                                <input type="radio"
                                    id="lp-config-tag-hub"
                                    name="radio-group"
                                    value="tagHub"
                                    data-bind="
                                        checked: listingPageConfigType,
                                        click: enableTagHubPage,
                                        disable: (isNotDeletable() && (originalListingPageConfigType() != 'tagHub' && !convertedToTagHub())) || lockRadioConfigType()
                                    "
                                >
                                <label class="form-label" for="lp-config-tag-hub">Database HUB</label>
                            </div>

                            <!-- ko if: !isTagHubEnabled() && listingPageConfigType() == 'tagHub' -->
                                <span class="warning-message">
                                    <i class="icon i-lock"></i><label class="form-label">Tag Hub</label>
                                </span>
                            <!-- /ko -->

                            <div class="form-check-inline width-auto">
                                <input type="radio"
                                    id="lp-config-channel"
                                    name="radio-group"
                                    value="channel"
                                    data-bind="
                                        checked: listingPageConfigType,
                                        disable: (idBrand() != 20) || (isNotDeletable() && (originalListingPageConfigType() != 'tagHub' && !convertedToTagHub())) || lockRadioConfigType()
                                    "
                                >
                                <label class="form-label" for="lp-config-channel" >Channel</label>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ko if: listingPageConfigType() == 'articles' || listingPageConfigType() == 'homepage_video' || listingPageConfigType() == 'homepage_thread'  || listingPageConfigType() == 'channel' || listingPageConfigType() == 'tagHub' -->

                        <div class="w-form-body no-border form-group-flex featured-pinned-section">
                        <!-- ko if: listingPageConfigType() != 'homepage_video' &&  listingPageConfigType() != 'tagHub' -->
                            <div class="form-body">
                                <strong class="form-sub-title pinned-articles">Pinned Articles</strong>
                                <!-- ko if: listingPageConfigType() != 'homepage_thread'-->
                                <div class="form-group row start " style="margin-top: .5rem">
                                    <div class="form-check-inline" style="width: auto;">
                                        <input type="checkbox" data-bind="checked: pinnedArticlesEnabled" class="input-checkbox" id="pinnedArticles">
                                        <label class="form-label icon i-check" for="pinnedArticles">Enable Pinned Articles</label>
                                    </div>
                                </div>
                                <!-- /ko -->
                                <!-- ko if: pinnedArticlesEnabled() -->
                                <!-- ko if: listingPageConfigType() != 'homepage_thread'  -->
                                    <div class="form-group column featured-pinned-template">
                                        <legend class="form-legend">Layout</legend>
                                        <div data-bind="foreach: activeLayoutOptions" class="featured-pinned-list">
                                            <div class="featured-pinned-element">
                                                <input type="radio" name="featured-template" data-bind="attr: {id: 'layoutOptions_' + id}, value: id, checked: $parent.idLayout, event:{ change : $parent.onChangeLayout }">
                                                <label class="form-label icon " data-bind="attr: {for: 'layoutOptions_' + id, class: 'form-label icon ' + wrappingClass }"></label>
                                                <!-- @TODO: remove the following commented block before launch and after it is decided how the user will be indicated the required number of pinned articles for the layout selected here. -->
                                                <!-- <div class="w-tooltips-adv pos-right" data-bind="template: { name: 'infoButton-template', data: $data.tooltip.getTemplateViewModel() }"></div> -->
                                            </div>
                                        </div>
                                    </div>
                                    <!-- /ko -->

                                    <div class="form-group">
                                        ${this.pinnedArticles.getHtmlBuild()}
                                    </div>
                                <!-- /ko -->
                            </div>
                        <!-- /ko -->
                        <!-- ko if: listingPageConfigType() == 'channel' -->
                            <div class="form-body">
                                <strong class="form-sub-title pinned-articles">Channel</strong>
                                <div class="form-group">
                                    ${this.channelFilter.getHtmlBuild()}
                                </div>
                            </div>
                        <!-- /ko -->
                        <!-- ko if: listingPageConfigType() != 'homepage_video' && listingPageConfigType() != 'homepage_thread' && listingPageConfigType() != 'channel' && listingPageConfigType() != 'tagHub' -->
                            <div class="form-body dc-pinned-tag">
                                <strong class="form-sub-title pinned-tag">Pinned Tag</strong>
                                <div class="form-group row">
                                    <button class="btn secondary icon i-tag"  data-bind="visible: !pinnedTag() || !pinnedTag().source,event: { click: onClickSelectPinnedTag }" type="button" data-bind="">Select Pinned Tag</button>
                                    <!-- ko if: pinnedTag -->
                                    <label for="type" class="form-label" style="margin: 0;">Pinned Tag</label>
                                    <div data-bind="visible: pinnedTag().source">
                                        <button class="btn-form icon i-edit" data-bind="event: { click: onClickPinnedTagEdit }" type="button" >Edit Selection</button>
                                        <button class="btn-form icon i-delete" data-bind="event: {click: onClickPinnedTagDelete}"></button>
                                    </div>
                                    <!-- /ko -->
                                </div>

                                <!-- ko if: pinnedTag -->
                                    <div id="pinnedTagDiv" class="form-group">

                                    </div>
                                <!-- /ko -->
                            </div>
                        <!-- /ko -->
                        </div>
                    <div class="w-form-body no-border form-group-flex featured-pinned-section">
                        <!-- Pinned Hub Pages -->
                        <!-- ko if: listingPageConfigType() != 'channel' && listingPageConfigType() != 'tagHub' -->
                        <div class="form-body ">

                            <strong class="form-sub-title pinned-hub-pages" data-bind="text: listingPageConfigType() == 'homepage_video' || listingPageConfigType() == 'homepage_thread' ? 'Primary Pinned Hub Pages' : 'Pinned Hub Pages'"></strong>

                            <div class="form-group pinned-hub-pages-section">
                                ${this.pinnedListingPages.getHtmlBuild()}
                            </div>
                        </div>
                        <!-- /ko -->

                        <!-- ko if: (!isNotDeletable() && listingPageConfigType() != 'homepage_video' && listingPageConfigType() != 'homepage_thread' && listingPageConfigType() != 'channel' && listingPageConfigType() != 'tagHub') || showTagHubSubContent() == true -->
                            <!-- SUB-CONTENT Articles -->
                            <div class="form-body form-section featured-article no-border">


                                <strong class="form-sub-title featured-article">Sub-Content Articles</strong>
                                <button class="form-section-btn icon i-plus" title="Add Article Content" type="button" data-bind="event: { click: onClickAddSubContentArticle }"><span class="hide">Sub-Content Articles</span></button>

                                ${this.subContentArticles.getHtmlBuild()}

                            </div>
                        <!-- /ko -->

                        <!-- ko if: !isNotDeletable() && listingPageConfigType() == 'homepage_video' || listingPageConfigType() == 'homepage_thread' -->
                            <div class="form-body">
                                <strong class="form-sub-title pinned-hub-pages">Secondary Pinned Hub Pages</strong>
                                <div class="form-group pinned-hub-pages-section">
                                    ${this.secondaryPinnedListingPages.getHtmlBuild()}
                                </div>
                            </div>
                        <!-- /ko -->
                    </div>
                <!-- /ko -->

                <!-- Hub Configuration -->
                <div class="w-form-body no-border">

                    <div class="form-body full-width">
                        <strong class="form-sub-title">HUB CONFIGURATION</strong>
                    </div>

                </div>

                <!-- ko if: isNotDeletable() && (listingPageConfigType() == 'articles' || listingPageConfigType() == 'homepage_video' || listingPageConfigType() == 'homepage_thread' || listingPageConfigType() == 'channel') -->
                    <div class="warning-message">
                        <i class="icon i-lock"></i><span>This configuration cannot be changed, as this page is reserved and used by other pages on the website.</span>
                    </div>
                    ${listingPagesView_template.getHubConfigurationViewHtml()}
                <!-- /ko -->

                <!-- ko ifnot: isNotDeletable() && (listingPageConfigType() == 'articles' || listingPageConfigType() == 'homepage_video' || listingPageConfigType() == 'homepage_thread' || listingPageConfigType() == 'channel') -->
                    <div class="w-form-body" style="margin-bottom: 2rem;">
                        <!-- ko if: listingPageConfigType() != 'tagHub' -->
                            <div class="form-body no-padding" >
                                <div class="form-group row">
                                <label class="form-label" for="type">Sort Order</label>
                                ${ this.typeSelector.getHtmlBuild() }
                                </div>

                                <div class="form-group row" data-bind="visible: selectedTypeIsTrending()" style="width: auto;">
                                    <input type="checkbox" data-bind="checked: randomizePinnedArticles" class="input-checkbox" id="randomizePinnedArticles">
                                    <label class="form-label icon i-check" for="randomizePinnedArticles">Randomize when Pinned</label>
                                </div>

                                <div class="form-group"><hr></div>
                            </div>
                            <!-- ko if: listingPageConfigType() != 'homepage_video' && listingPageConfigType() != 'homepage_thread' && listingPageConfigType() != 'channel'-->
                                <div class="form-body no-padding">
                                    <div class="form-group row start" >
                                        <div class="form-check-inline" style="width: auto;">
                                            <input type="checkbox" data-bind="checked: listingPageInterlinkEnabled" class="input-checkbox" id="listingPageInterlinkEnabled">
                                            <label class="form-label icon i-check" for="listingPageInterlinkEnabled">Interlink with Related Listing Pages</label>
                                        </div>
                                        <div class="w-tooltips-adv pos-top short" style="margin-top: .5rem">
                                            ${this.listingPageInterlinkEnabledTooltip.getHtmlBuild()}
                                        </div>
                                    </div>
                                    <div class="form-group"><hr></div>
                                </div>
                            <!-- /ko -->
                        <!-- /ko -->
                    </div>

                    <!-- Tag hub -->
                    <div class="w-form-body" data-bind="visible: listingPageConfigType() == 'tagHub'">
                        <div class="form-body no-padding">
                            <div class="form-group tags">
                                <label class="form-legend" for="permalink">Hub Tag Selection</label>
                                ${this.tagHubTagFilter.getHtmlBuild()}
                            </div>
                        </div>
                    </div>

                    <!-- List of Tags -->
                    <div class="w-form-body" data-bind="visible: listingPageConfigType() == 'tags'">
                        <div class="form-body no-padding">
                            <div class="form-group row inside-label" style="margin-bottom: 5rem">
                                <div style="width: calc(100% - 3rem);" class="with-tooltip">
                                    ${this.tagTypeFilter.getHtmlBuild()}
                                </div>
                                <div class="w-tooltips-adv pos-right short">
                                    ${this.tagTypeTooltip.getHtmlBuild()}
                                </div>
                            </div>

                            <div  data-bind="visible: listingPageConfigType() == 'tags' && tagType()">

                                ${this.inclusionRules.getHtmlBuild()}
                            </div>

                        </div>
                        <div class="form-body no-padding">
                            <div class="form-group row" data-bind="visible: listingPageConfigType() == 'tags' && tagType() , event: { change: onSelectSpecificationFilter }">
                                <label class="form-label no-wrap">Specification <br>Filter Level 1</label>

                                <div style="flex: 1 auto;">
                                    ${this.level1Filter.getHtmlBuild()}
                                </div>

                                <div class="w-tooltips-adv pos-far-left short" style="margin-top: 1rem">
                                    ${this.level1FilterTooltip.getHtmlBuild()}
                                </div>
                            </div>
                            <div class="form-group row" data-bind="visible: listingPageConfigType() == 'tags' && tagType()">
                                <label class="form-label">Specification <br>Filters Level 2</label>
                                <div style="flex: 1 auto;">
                                    ${this.level2Filter.getHtmlBuild()}
                                </div>
                                <div class="w-tooltips-adv pos-far-left short" style="margin-top: 1rem">
                                    ${this.level2FilterTooltip.getHtmlBuild()}
                                </div>
                            </div>

                            <div data-bind="visible: showSpecToDisplay && listingPageConfigType() == 'tags' && tagType() ">
                                <div class="form-group"><hr></div>
                                <div class="form-group row" data-bind="visible: listingPageConfigType() == 'tags' && tagType(), event: { change: onSelectDisplaySpec }">
                                    <label class="form-label no-wrap">Spec to Display</label>

                                    <div style="flex: 1 auto;">
                                        ${this.specToDisplay.getHtmlBuild()}
                                    </div>
                                    <div class="w-tooltips-adv pos-far-left short" style="margin-top: 1rem">
                                        ${this.specToDisplayTooltip.getHtmlBuild()}
                                    </div>
                                </div>
                                <div class="form-group" data-bind="visible: onSelectOrder">
                                    <input type="radio" id="Asc" name="radio-group-Asc" value="Asc" data-bind="checked: specToDisplayAscDesc">
                                    <label class="form-label" for="Asc" >ASC</label>
                                    <input type="radio" id="Desc" name="radio-group-Desc" value="Desc" data-bind="checked: specToDisplayAscDesc">
                                    <label class="form-label" for="Desc" >DESC</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- List of Articles -->
                    <div class="w-form-body">

                        <div class="form-body no-padding" data-bind="visible: listingPageConfigType() == 'articles'">

                            <div class="form-group start">
                                <label class="form-legend" style="display: block;" for="permalink">Article Characteristics</label>
                                <div class="form-check-inline" style="width: auto;">
                                    ${this.filterArticleCharacteristics.getHtmlBuild()}
                                    <div style="display: none;" id="selected_articleCharacteristics" class="filters-selected"></div>
                                </div>
                            </div>
                            <div class="form-group" data-bind="foreach: selectedArticleCharacteristics">
                                <div  class="btn-selection">
                                    <span data-bind="text: name"></span>
                                    <button data-bind="event: {click: $parent.onClickDeleteSelectedArticleCharacteristics}, disable: $parent.isNotDeletable()" class="icon i-x-after" type="button"></button>
                                </div>
                            </div>

                            <div class="form-group">
                                <legend class="form-legend">Content Types</legend>
                                ${this.filterContentType.getHtmlBuild()}
                                <div style="display: none;" id="selected_contentTypes" class="filters-selected"></div>
                            </div>
                            <div class="form-group" data-bind="foreach: selectedContentTypes">
                                <div  class="btn-selection">
                                    <span data-bind="text: name"></span>
                                    <button data-bind="event: {click: $parent.onClickDeleteSelectedContentType}, disable: $parent.isNotDeletable()" class="icon i-x-after" type="button"></button>
                                </div>
                            </div>

                            <div class="form-group" data-bind="visible: segmentsEnabled()">
                                <legend class="form-legend">Segments</legend>
                                ${this.filterSegments.getHtmlBuild()}
                                <div style="display: none;" id="selected_segments" class="filters-selected"></div>
                            </div>
                            <div class="form-group" data-bind="foreach: selectedSegments">
                                <div  class="btn-selection">
                                    <span data-bind="text: name"></span>
                                    <button data-bind="event: {click: $parent.onClickDeleteSelectedSegments}, disable: $parent.isNotDeletable()" class="icon i-x-after" type="button"></button>
                                </div>
                            </div>
                        </div>

                        <div class="form-body no-padding" data-bind="visible: listingPageConfigType() == 'articles' || listingPageConfigType() == 'homepage_video' || listingPageConfigType() == 'homepage_thread' || listingPageConfigType() == 'channel'">
                            <div class="form-group row">
                                <label class="form-label" for="articleType">Article Type</label>
                                ${ this.articleTypeSelector.getHtmlBuild() }
                            </div>
                            <!-- ko if: listingPageConfigType() != 'homepage_video' && listingPageConfigType() != 'homepage_thread'  && listingPageConfigType() != 'channel' -->
                                <div class="form-group tags">
                                    <label class="form-legend" for="permalink">Tags</label>
                                    ${this.tagFilter.getHtmlBuild()}
                                </div>

                                <div class="form-group" data-bind="foreach: pinnedTags, hidden: tagType()">
                                    <div  class="btn-selection">
                                        <span data-bind="text: name + (type != null ? ' ' + formattedTagTypeAndDataset : '')"></span>
                                        <button data-bind="event: {click: $parent.onClickRemovePinnedTag}, disable: $parent.isNotDeletable()" class="icon i-x-after" type="button"></button>
                                    </div>
                                </div>

                                <div class="form-group">
                                    <legend class="form-legend">Categories</legend>
                                    ${this.filterCategory.getHtmlBuild()}
                                    <div style="display: none;" id="selected_categories" class="filters-selected"></div>
                                </div>
                                <div class="form-group" data-bind="foreach: selectedCategories">
                                    <div  class="btn-selection">
                                        <span data-bind="text: name"></span>
                                        <button data-bind="event: {click: $parent.onClickDeleteSelectedCategory}, disable: $parent.isNotDeletable()" class="icon i-x-after" type="button"></button>
                                    </div>
                                </div>
                            <!-- /ko -->
                        </div>
                    </div>
                <!-- /ko -->

                <!-- ko if: listingPageConfigType() == 'articles' && !isNotDeletable() -->
                    <div class="w-form-body no-border">
                        <div class="form-body embed no-padding" data-bind="visible: (idBrand() == 5 || idBrand() == 6 || idBrand() == 22)">
                            <strong class="form-sub-title icon i-dropdown-simple is-open"  data-bind="click: collapseEmbedSection, css: { 'is-open' : isEmbedSectionCollapsed }">
                                Embed
                                <button class="form-section-btn icon i-plus" type="button" data-bind="visible: !embedHTML(), event: {click: onClickOpenEmbeds}"><span class="hide">Add Embed</span></button>
                            </strong>
                            <div class="form-group row top listing-embed" style="margin-bottom: 0;">
                                ${this.embedder.getHtmlBuild()}
                                <div class="form-embed" id="embedder-preview"></div>

                                <button class="btn highlight icon border only-icon i-close" data-bind="visible: embedHTML(), event: {click: onClickRemoveEmbed}" class="icon i-x-after" type="button"></button>
                            </div>
                        </div>
                    </div>

                <!-- /ko -->
                    <div class="w-form-body no-border">
                        <div class="form-body">
                            ${this.tagPicker.getHtmlBuild()}
                        </div>
                    </div>

            <div class="form-footer">
                <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
            </div>

            ${this.imagePicker.getHtmlBuild()}

            <div class="w-lightbox light-theme " data-bind="css: { 'is-visible': isSubContentArticlePopupVisible }">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Sub-Content Article</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="click: onCLickCloseSubContentArticlePopup"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                ${this.subContentArticlesFilter.getHtmlBuild()}
                            </div>
                            </div>

                        <div class="form-footer">
                            <button type="button" class="btn" data-bind="click: onCLickCloseSubContentArticlePopup">Cancel</button>
                            <button type="button" class="btn highlight" data-bind="click: onCLickApplySubContentArticlePopup">Apply</button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-lightbox light-theme " data-bind="css: { 'is-visible': isNewTagHubPopupVisible() }">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Convert to Database HUB</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="click: onClickCloseNewTagHubPopup"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <div style="margin:0.5rem">Are you sure you want to convert this page into a Hub?</div>
                                <div style="margin:0.5rem">All custom configuration options will be disabled and a the page will automatically be built off the data in the Tag.</div>
                                <!-- ko if: isNewTagHubPopupErrorsVisible() -->
                                <div>
                                    <div style="margin:0.5rem">In order to be eligible, the Tag must have the following filled out:</div>
                                    <ul style="margin:0.5rem 1.0rem;">
                                        <!-- ko if: tagHubTagErrors().image && tagHubTagErrors().image.length > 0 -->
                                        <li style="margin:0.5rem">
                                            Image
                                            <!-- ko foreach: tagHubTagErrors().image -->
                                                <span style="color:red;" data-bind="text: $data"></span>
                                            <!-- /ko -->
                                        </li>
                                        <!-- /ko -->

                                        <!-- ko if: tagHubTagErrors().bannerImage && tagHubTagErrors().bannerImage.length > 0 -->
                                        <li style="margin:0.5rem">
                                            Banner Image
                                            <!-- ko foreach: tagHubTagErrors().bannerImage -->
                                                <span style="color:red;" data-bind="text: $data"></span>
                                            <!-- /ko -->
                                        </li>
                                        <!-- /ko -->

                                        <!-- ko if: tagHubTagErrors().description && tagHubTagErrors().description.length > 0 -->
                                        <li style="margin:0.5rem">
                                            Description
                                            <!-- ko foreach: tagHubTagErrors().description -->
                                                <span style="color:red;" data-bind="text: $data"></span>
                                            <!-- /ko -->
                                        </li>
                                        <!-- /ko -->

                                        <!-- ko if: tagHubTagErrors().video && tagHubTagErrors().video.length > 0 -->
                                        <li style="margin:0.5rem">
                                            Video
                                            <!-- ko foreach: tagHubTagErrors().video -->
                                                <span style="color:red;" data-bind="text: $data"></span>
                                            <!-- /ko -->
                                        </li>
                                        <!-- /ko -->

                                        <!-- ko if: tagHubTagErrors().specs && tagHubTagErrors().specs.length > 0 -->
                                        <li style="margin:0.5rem">
                                            Core Specs relevant to its Tag Type
                                            <!-- ko foreach: tagHubTagErrors().specs -->
                                                <span style="color:red;" data-bind="text: $data"></span>
                                            <!-- /ko -->
                                        </li>
                                        <!-- /ko -->
                                    </ul>
                                </div>
                                <!-- /ko -->
                            </div>
                            <div class="form-group">
                                ${this.tagHubTagFilter.getHtmlBuild()}
                            </div>
                        </div>

                        <div class="form-footer">
                            <button type="button" class="btn" data-bind="click: onClickCloseNewTagHubPopup">Cancel</button>
                            <button type="button" class="btn highlight" data-bind="click: onClickConfirmNewTagHub, disable: !isHubTagSelectionSet() || tagHubTagHasErrors()">Confirm</button>
                        </div>
                    </div>
                </div>
            </div>

            ${this.videoPicker.getHtmlBuild()}
        `;

        // @TODO: replace inline styles below with proper scss ex. style="margin-left: -1.2rem;transform: translateY(0.5rem);"
    }

    protected initPartial(): void {

        this.tagFilter = new filterTag_template("tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagHubTagFilter = new filterTag_template("tagHubTagFilter", this.getTemplateViewModel(), this.caller);
        this.level2Filter = new filterDropdown_template("level2Filter", this.getTemplateViewModel(), this.caller)
        this.tagTypeFilter = new filterAutocomplete_template("tagTypeFilter", this.getTemplateViewModel(), this.caller);
        this.tagTypeFilter.setPlaceholderAndLabel('Tag Type');
        this.tagTypeFilter.setOptionType("Tag Type");
        this.tagTypeFilter.setNumberOfChars(1);
        this.tagTypeFilter.setAddNewOptionEnabled(false);
        this.tagTypeFilter.setFilterIconCSSClass('i-tag-type-a');
        this.typeSelector = new filterDropdown_template('typeSelector', this.getTemplateViewModel(), this.caller);
        this.articleTypeSelector = new filterDropdown_template('articleTypeSelector', this.getTemplateViewModel(), this.caller);
        this.level1Filter = new filterDropdown_template('level1Filter', this.getTemplateViewModel(), this.caller);
        this.specToDisplay = new filterDropdown_template('specToDisplay', this.getTemplateViewModel(), this.caller);
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this.caller);
        this.embedder = new embedder_template("embedder", this.getTemplateViewModel(), this.caller);
        this.inclusionRules = new inclusionRules_template('inclusionRules', this.getTemplateViewModel(), this.caller);
        this.imagePicker = new imagePicker_template("imagePicker", this.getTemplateViewModel(), this.caller);
        this.imagePicker.setNumberOfRecentImages(50);

        this.tagPicker = new tagPicker_template("tagPicker", this.getTemplateViewModel(), this.caller);
        this.tagPicker.setIsSingle(true);
        this.tagPicker.setParent(this);

        this.tagTypeTooltipContent = `
        <p>
        Previews of tags from the selected type will populate the page. Users can then navigate to the individual tag page if one exists.
        </p>
        `
        this.pinnedTagCardTooltipContent = `
        <p>
        This tag will appear at the top of the Hub page.
        </p>
        `

        this.level1FilterTooltipContent = `
        <p>
        This selection is mandatory and determines how the tags will be organized on the listing page. All valid combinations will be created as pages.
        </p>
        `

        this.level2FilterTooltipContent = `
        <p>
        This selection is optional and provides an additional option for limiting the tags displayed on the listing page. All valid combinations will be created as pages.
        </p>
        `

        this.specToDisplayTooltipContent = `
        <p>The chosen spec in this drop-down will determine what will appear with each tag listed on the page.  This can be different from the "Specification Filter".</p>
        <p>e.g. List of tags of type <strong>"Person"</strong> can have specification filter <strong>"Profession"</strong> and the displayed spec <strong>"Networth"</strong>.  This results in generating list of people being grouped by matching profession on the same page, and sorted by their networth.</p>
        <p>If no spec is chosen to display, the list of tags will be defaulted to sort alphabetically, by their name</p>
        `

        this.listingPageConfigTooltipContent = `
        <p>
        Parameters such as as Content Types, Tags, and Categories are available to use in deciding what will appear in a list of articles. Anything selected in those parameters will dictate what populates on the page. At least one parameter must be selected but any additional parameters are optional.
        </p>
        `

        this.listingPageNoUrlTooltipContent = `
        <p>
        This enables the website to have access to a list of articles without displaying them on a dedicated page. This list can then be used to populate other pages. For example, a list can be pinned to the homepage, sidebar, or another listing page. Once pinned, a finite number of articles will be displayed, leaving the rest inaccessible.
        </p>
        `
        this.listingPageInterlinkEnabledTooltipContent = `
            <p>When the interlink option is activated, the page will automatically display other listing pages based on:</p>
            <ul>
                <li>Above Latest: Listing pages with same category/tags selected, but different content type options.</li>
                <li>
                    <p>Sidebar:</p>
                    <ul style="margin-left: -3rem; margin-top: 1.5rem;">
                        <li>If both category and content types are selected (with or without tag), sidebar will have pages with same options, but different tag selections.</li>
                        <li>If only content types are selected, sidebar will have pages of same content type, but different categories.</li>
                        <li>If only category is selected, sidebar will have pages of different categories and no content type or tag.</li>
                        <li>In all other cases, the sidebar will display all other listing pages that have the same tag selections.</li>
                    </ul>
                </li>
            </ul>
        `

        this.randomizePinnedArticlesTooltipContent = `
            <p>Randomize Pinned Articles</p>
        `

        this.tagTypeTooltip = new infoButton_template('tagTypeTooltip', this.getTemplateViewModel(), this.caller)
        this.tagTypeTooltip.setTitle('Tag Type');
        this.tagTypeTooltip.setContent(this.tagTypeTooltipContent);

        this.level1FilterTooltip = new infoButton_template('level1FilterTooltip', this.getTemplateViewModel(), this.caller)
        this.level1FilterTooltip.setTitle('Specification Field Filter Level 1');
        this.level1FilterTooltip.setContent(this.level1FilterTooltipContent);

        this.level2FilterTooltip = new infoButton_template('level2FilterTooltip', this.getTemplateViewModel(), this.caller)
        this.level2FilterTooltip.setTitle('Specification Field Filter Level 2');
        this.level2FilterTooltip.setContent(this.level2FilterTooltipContent);

        this.specToDisplayTooltip = new infoButton_template('specToDisplayTooltip', this.getTemplateViewModel(), this.caller)
        this.specToDisplayTooltip.setTitle('Spec To Display');
        this.specToDisplayTooltip.setContent(this.specToDisplayTooltipContent);

        this.listingPageConfigTooltip = new infoButton_template('listingPageConfigTooltip', this.getTemplateViewModel(), this.caller)
        this.listingPageConfigTooltip.setTitle('List of Articles');
        this.listingPageConfigTooltip.setContent(this.listingPageConfigTooltipContent);

        this.listingPageNoUrlTooltip = new infoButton_template('listingPageNoUrlTooltip', this.getTemplateViewModel(), this.caller)
        this.listingPageNoUrlTooltip.setTitle('URL NOT NEEDED');
        this.listingPageNoUrlTooltip.setContent(this.listingPageNoUrlTooltipContent);

        this.listingPageInterlinkEnabledTooltip = new infoButton_template('listingPageInterlinkEnabledTooltip', this.getTemplateViewModel(), this.caller)
        this.listingPageInterlinkEnabledTooltip.setTitle('Interlink with Related Listing Pages');
        this.listingPageInterlinkEnabledTooltip.setContent(this.listingPageInterlinkEnabledTooltipContent);

        this.randomizePinnedArticlesTooltip = new infoButton_template('randomizePinnedArticlesTooltip', this.getTemplateViewModel(), this.caller)
        this.randomizePinnedArticlesTooltip.setTitle('Randomize Pinned Articles');
        this.randomizePinnedArticlesTooltip.setContent(this.randomizePinnedArticlesTooltipContent);

        this.pinnedArticles = new pinnedArticles_template('pinnedArticles', this.getTemplateViewModel(), this.caller);
        this.pinnedArticles.setIsToolTipVisible(true);
        this.pinnedArticles.tooltip.setContent('<p>This determines for how long the article will remain pinned on the listing page. Once the time expires, the position will be filled with the most recent/trending article (matching on the selected sort order). If you would like this article pinned indefinitely, leave the hours field empty.</p>')

        this.pinnedListingPages = new pinnedListingPages_template('pinnedListingPages', this.getTemplateViewModel(), this.caller);
        this.pinnedListingPages.setMaximum(100);
        this.pinnedListingPages.setParent(this);
        this.pinnedListingPages.setIsToolTipVisible(true);
        this.pinnedListingPages.tooltip.setContent('<p>This allows the pinning of a separate listing page as a widget on the website. The pinned listing page will display a preview of articles within it.</p>');

        this.secondaryPinnedListingPages = new secondaryPinnedListingPages_template('secondaryPinnedListingPages', this.getTemplateViewModel(), this.caller);
        this.secondaryPinnedListingPages.setMaximum(100);
        this.secondaryPinnedListingPages.setParent(this);
        this.secondaryPinnedListingPages.setIsToolTipVisible(true);
        this.secondaryPinnedListingPages.tooltip.setContent('<p>This allows the pinning of a separate listing page as a widget on the website. The pinned listing page will display a preview of articles within it.</p>')

        this.subContentArticles = new subContentArticles_template('subContentArticles', this.getTemplateViewModel(), this.caller);
        this.subContentArticles.setParent(this);
        this.subContentArticlesFilter =  new filterArticle_template('subContentArticlesFilter', this.getTemplateViewModel(), this.caller);
        this.subContentArticlesFilter.setShowDetails(true);
        this.subContentArticlesFilter.setIsLoadingAnimationEnable(true);

        this.filterCategory = new multipleSelector_template("listingpage_categoryFilter", this.getTemplateViewModel(), this.caller);
        this.filterCategory.setFilterContainerClass('margin-neg');
        this.filterCategory.setSelectAllEnabled(false);
        this.filterCategory.setSearchEnabled(true);
        this.filterCategory.setTagContainerId('selected_categories');
        this.filterCategory.setLabel("Categories");

        this.filterContentType = new multipleSelector_template("listingpage_contentTypeFilter", this.getTemplateViewModel(), this.caller);
        this.filterContentType.setFilterContainerClass('margin-neg');
        this.filterContentType.setSelectAllEnabled(false);
        this.filterContentType.setSearchEnabled(true);
        this.filterContentType.setTagContainerId('selected_contentTypes');
        this.filterContentType.setLabel("Content Types");

        this.filterArticleCharacteristics = new multipleSelector_template("listingpage_articleCharacteristicsFilter", this.getTemplateViewModel(), this.caller);
        this.filterArticleCharacteristics.setFilterContainerClass('margin-neg');
        this.filterArticleCharacteristics.setTagContainerId('selected_articleCharacteristics');
        this.filterArticleCharacteristics.setLabel("Article Characteristics");
        this.filterArticleCharacteristics.setSelectAllEnabled(false);
        this.filterArticleCharacteristics.setSearchEnabled(false);

        this.filterSegments = new multipleSelector_template("listingpage_segmentsFilter", this.getTemplateViewModel(), this.caller);
        this.filterSegments.setFilterContainerClass('margin-neg');
        this.filterSegments.setSelectAllEnabled(false);
        this.filterSegments.setSearchEnabled(false);
        this.filterSegments.setTagContainerId('selected_segments');
        this.filterSegments.setLabel("Segments");

        this.listingPagePermalinkFilter = new filterListingPage_template("filterPermalinkListingPage", this.getTemplateViewModel(), this.caller);
        this.listingPagePermalinkFilter.setPlaceholder("Linked Hub Page");
        this.listingPagePermalinkFilter.setShowDetails(true);
        this.listingPagePermalinkFilter.setIsLoadingAnimationEnable(true);

        this.videoPicker = new videoPicker_template("videoPicker", this.getTemplateViewModel(), this.caller);

        this.videoPickerHelper = new videoPickerHelper(
            this.videoPicker,
            this.caller.viewModel,
            this.caller.getVnAppZone(),
            this.caller
        );

        this.channelFilter = new filterAutocomplete_template("channelFilter", this.getTemplateViewModel(), this.caller);
        this.channelFilter.setPlaceholderAndLabel('Channels' );
        this.channelFilter.setOptionType("Channels");
        this.channelFilter.setIsShowCurrentSelection(true);
        this.channelFilter.setAddNewOptionEnabled(false);
    }

    protected getTemplateName(): string {
        return "listingPagesEdit_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-form", "w-form-large"];
    }


    protected buildViewModel(): any {

        let self = this;
        let viewModel = {
            id: ko.observable(0),
            idBrand: ko.observable(0),
            name: ko.observable(''),
            permalink: ko.observable(''),
            permalinkBehavior: ko.observable("1"),
            permalinkListingPage: ko.observableArray([]),
            listingPageInterlinkEnabled: ko.observable(false),
            randomizePinnedArticles: ko.observable(false),
            selectedTypeIsTrending: ko.observable(false),
            pinnedArticles: ko.observableArray([]),
            pinnedArticlesEnabled: ko.observable(false),
            pinnedTagEnabled: ko.observable(false),
            layoutOptions: ko.observableArray([]),
            activeLayoutOptions: ko.observableArray([]),
            idLayout: ko.observable(1),
            description: ko.observable(''),
            lockRadioPermalinks: ko.observable(false),
            lockPermalinkInput: ko.observable(false),
            lockRadioConfigType: ko.observable(false),
            listingPageConfigType: ko.observable('articles'),
            originalListingPageConfigType: ko.observable('articles'),
            selectedCategories:  ko.observableArray([]),
            selectedContentTypes: ko.observableArray([]),
            selectedArticleCharacteristics: ko.observableArray([]),
            selectedSegments: ko.observableArray([]),
            segments: (ko.observableArray([])),
            tagTypes: (ko.observableArray([])),
            pinnedTags : (ko.observableArray([])),
            tagType :  ko.observable(),
            pinnedTagCard :  ko.observable(),
            filters :  ko.observableArray([]),
            isEmbedSectionCollapsed: ko.observable(false),
            embedHTML : ko.observable(),
            specToDisplayAscDesc: ko.observable(''),
            showSpecToDisplay: ko.observable(false),
            onSelectOrder: ko.observable(false),
            pinnedTag: ko.observable(null), // a display card
            imagePickerTarget: ko.observable(null),
            permissions: ko.observableArray(this.initPermissions(['article_edit_config_affiliate_linker'])),
            segmentsEnabled: ko.observable(false),
            isSubContentArticlePopupVisible: ko.observable(false),
            hasShownHubConfigurationPopup: ko.observable(false),
            isNewTagHubPopupVisible: ko.observable(false),
            isNewTagHubPopupErrorsVisible: ko.observable(false),
            subContentArticle: ko.observable(null),
            isNotDeletable: ko.observable(false),
            showTagHubSubContent: ko.observable(false),
            isHub: ko.pureComputed(() => self.getTemplateViewModel()? self.getTemplateViewModel().listingPageConfigType() == 'tagHub' : false),
            isHubTagSelectionSet: ko.pureComputed(() => !!self.tagHubTagFilter && !!self.tagHubTagFilter.getTagObj()),
            tagHubTagErrors: ko.observable({
                image: [],
                bannerImage: [],
                description: [],
                video: [],
                specs: [],
            }),
            isTagHubEnabled: ko.observable(false),
            tagHubTagTypeRestrictions: (ko.observableArray([])),
            tagHubTagHasErrors: ko.pureComputed(() => {
                const errors = self.getTemplateViewModel().tagHubTagErrors();

                return errors.image.length || errors.bannerImage.length || errors.description.length || errors.video.length || errors.specs.length;
            }),
            convertedToTagHub: ko.observable(false),
            /** section of computed values for displaying the hub configuration view when isNotDeletable and is article type. */
            config: ko.pureComputed(() => self.getTemplateViewModel().listingPageConfigType()),
            type: ko.pureComputed(() => self.typeSelector.getSelectedOption()? self.typeSelector.getSelectedOption().name : ''),
            articleTypeName: ko.pureComputed(() => self.articleTypeSelector.getSelectedOption()? self.articleTypeSelector.getSelectedOption().name : ''),
            articleCharacteristicsString: ko.pureComputed(() => self.getTemplateViewModel().selectedArticleCharacteristics()? self.getTemplateViewModel().selectedArticleCharacteristics().map((item) => item.name).join(', ') : ''),
            contentTypes: ko.pureComputed(() => self.getTemplateViewModel().selectedContentTypes()? self.getTemplateViewModel().selectedContentTypes() : []),
            categories: ko.pureComputed(() => self.getTemplateViewModel().selectedCategories()? self.getTemplateViewModel().selectedCategories() : []),
            /** end section of computed values for displaying the hub configuration view when isNotDeletable and is article type. */
            onFocusOutListingPageName: (listingPageName, listingPagePermalink) => {
                self.onFocusOutListingPageName(listingPageName, listingPagePermalink);
            },
            onClickSave: (data, event) => {
                self.onClickSave();
            },
            onSelectSpecificationFilter: (data,event) =>{
                self.onSelectSpecificationFilter(data,event);
            },
            onSelectDisplaySpec: (data,event)=>{
              self.onSelectDisplaySpec(data,event);
            },
            onClickCancel: (data, event) => {
                self.onClickCancel();
            },
            onClickRemovePinnedTag: (data) => {
                self.onClickRemovePinnedTag(data);
            },
            onClickRemoveTagType: (data) => {
                self.onClickRemoveTagType();
            },
            onClickRemovePinnedListingPage: (data) => {
                self.onClickRemovePinnedListingPage(data);
            },
            onClickRemoveEmbed: (data) => {
                self.onClickRemoveEmbed();
            },
            onClickRemovePinnedArticle: (data) => {
                self.onClickRemovePinnedArticle(data);
            },
            viewOnWebsite: (value, data, event) => {
                self.viewOnWebsite(value);
            },
            onClickOpenEmbeds: (data) => {
                self.embedder.toggleEmbedPopUp(true);
            },
            onClickCloseEmbeds: (data) => {
                self.embedder.toggleEmbedPopUp(false);
            },
            setEmbedHTML: (data) => {
                self.setEmbedHTML(data);
            },
            collapseEmbedSection: function (value, data, event) {
                self.collapseEmbedSection();
            },
            onChangeLayout: function(data, event){
                self.updatePinnedArticleMaximumNumber();
            },
            onClickSelectPinnedTag: function (value, data, event) {
                self.onClickSelectPinnedTag();
            },
            onClickPinnedTagEdit: function (data, event) {
                self.onClickPinnedTagEdit();
            },
            onClickPinnedTagDelete: function (data, event) {
                self.onClickPinnedTagDelete();
            },
            onClickSelectAsPinned: function (data, event) {
                self.onClickSelectAsPinned(data);
            },
            onClickDeleteSelectedCategory: function (data, event) {
                self.onClickDeleteSelectedCategory(data);
            },
            onClickDeleteSelectedContentType: function (data, event) {
                self.onClickDeleteSelectedContentType(data);
            },
            onClickDeleteSelectedSegments: function (data, event) {
                self.onClickDeleteSelectedSegments(data);
            },
            onClickDeleteSelectedArticleCharacteristics: function (data, event) {
                self.onClickDeleteSelectedArticleCharacteristics(data);
            },
            onClickAddSubContentArticle: function (data, event) {
                self.onClickAddSubContentArticle();
            },
            onCLickCloseSubContentArticlePopup: function (data, event) {
                self.onCLickCloseSubContentArticlePopup();
            },
            onCLickApplySubContentArticlePopup: function (data, event) {
                self.onCLickApplySubContentArticlePopup();
            },
            enableTagHubPage: () => self.enableTagHubPage(),
            onClickCloseNewTagHubPopup: () => self.onClickCloseNewTagHubPopup(),
            onClickConfirmNewTagHub: () => self.onClickConfirmNewTagHub(),
        };

        viewModel.listingPageConfigType.subscribe(function (newValue) {
            self.clearOtherTabs(newValue);
        }, viewModel);

        return viewModel;
    }

    // region Embeds

    protected collapseEmbedSection() {

        this.getTemplateViewModel().isEmbedSectionCollapsed(!this.getTemplateViewModel().isEmbedSectionCollapsed());
    }

    public resetEmbedPopUp(){

        this.getTemplateViewModel().embedHTML(null);
        document.getElementsByClassName('inner-group')[0].classList.remove('is-open');
        document.getElementsByClassName('btn-form options')[0].classList.add('is-open');

    }
    public onClickCloseEmbedPopup(){

        this.caller.abortEmbedGeneration();
        this.collapseEmbedSection();
        this.resetEmbedPopUp();
    }

    // endregion embeds

    private viewOnWebsite(value) {

        this.caller.viewOnWebsite(value.permalink());
    }

    public getViewModelForRequest() {
        return {
            id: this.getTemplateViewModel().id,
            idBrand: this.getTemplateViewModel().idBrand,
            name: this.getTemplateViewModel().name,
            permalink: this.getTemplateViewModel().permalink,
            permalinkBehavior: this.getTemplateViewModel().permalinkBehavior,
            permalinkListingPageId: this.listingPagePermalinkFilter.getTemplateViewModel().idListingPage(),
            description: this.getTemplateViewModel().description,
            type: this.typeSelector.getTemplateViewModel().selectedOption,
            idArticleType: this.articleTypeSelector.getTemplateViewModel().selectedOption,
            categories: this.filterCategory.getSelectedItems(),
            contentTypes: this.filterContentType.getSelectedItems(),
            articleCharacteristics: this.filterArticleCharacteristics.getSelectedItems(),
            segments: this.filterSegments.getSelectedItems(),
            idPinnedTag: this.getTemplateViewModel().idPinnedTag,
            tagType: this.tagTypeFilter.getTemplateViewModel().optionObj,
            tags: this.getPinnedTagIds(),
            tagHubTagId: this.tagHubTagFilter.getTagObj()? this.tagHubTagFilter.getTagObj().id : null,
            listingPages: this.getPinnedListingPages(),
            level1Filter: this.level1Filter.getTemplateViewModel().selectedOption,
            level2Filter: this.level2Filter.getTemplateViewModel().selectedOption,
            specToDisplay: this.specToDisplay.getTemplateViewModel().selectedOption,
            listingPageConfig: this.getTemplateViewModel().listingPageConfigType,
            embed: this.getTemplateViewModel().embedHTML,
            pinnedArticles: this.getPinnedArticles(),
            idLayout: this.getTemplateViewModel().idLayout,
            pinnedArticlesEnabled: this.getTemplateViewModel().pinnedArticlesEnabled,
            listingPageInterlinkEnabled: this.getTemplateViewModel().listingPageInterlinkEnabled,
            randomizePinnedArticles: this.getTemplateViewModel().randomizePinnedArticles,
            inclusionRules: this.inclusionRules.getRequestParameters(),
            specToDisplayAscDesc: this.getTemplateViewModel().specToDisplayAscDesc(),
            pinnedTag: this.getTemplateViewModel().pinnedTag(),
            idVignette: this.tagPicker.tagEdit.getTemplateViewModel().idVignette,
            subContentArticles: this.subContentArticles.getArticles(),
            idChannel: this.channelFilter.getOptionObj() ? this.channelFilter.getOptionObj().id : null
        }
    }

    protected onClickSave(): void {
        this.caller.save();
    }

    protected onFocusOutListingPageName(listingPageName, listingPagePermalink) {
        if (listingPagePermalink() === '' && listingPageName() !== '') {
            this.generatePermalink(listingPageName());
        }
    }

    protected enableTagHubPage()
    {
        const vm = this.getTemplateViewModel();

        if (vm.hasShownHubConfigurationPopup()) {
            vm.listingPageConfigType('tagHub');
            vm.isNotDeletable(true);
            vm.permalinkBehavior(1);
            this.clearOtherTabs('tagHub');
            return true;
        }

        vm.isNewTagHubPopupVisible(true);
        if (vm.pinnedTag()) {
            this.setPinnedTag(vm.pinnedTag());
        }

        return false;
    }

    protected onClickCloseNewTagHubPopup()
    {
        const vm = this.getTemplateViewModel();

        vm.isNewTagHubPopupVisible(false);
        vm.isNewTagHubPopupErrorsVisible(false);
        vm.setTagHubTagErrors([]);
        vm.listingPageConfigType('articles');
    }

    protected onClickConfirmNewTagHub()
    {
        const vm = this.getTemplateViewModel();

        const tag = this.tagHubTagFilter.getTagObj();

        if (tag && tag.idType && this.tagTypesRequiresArticleSubContent.indexOf(Number(tag.idType)) !== -1) {
            vm.showTagHubSubContent(true);
        } else {
            vm.showTagHubSubContent(false);
        }

        vm.isNewTagHubPopupVisible(false);
        vm.hasShownHubConfigurationPopup(true);
        vm.isNotDeletable(true);
        vm.name(tag.name);

        let tagType = tag.tagType? tag.tagType : tag.type.name;
        let tagTypeId = tag.idType? tag.idType : tag.type.id;
        let carModel = tag.model || undefined;
        let carMake = tag.make || undefined;


        if(tagTypeId == 971 && carModel && carMake) {
            vm.permalink(`/cars/${makePermalinkFromTitle(carMake)}/${makePermalinkFromTitle(carModel)}/`);
        } else if(tagTypeId == 972 && carModel && carMake) {
            let year = tag.name.substring(0, 4);
            vm.permalink(`/cars/${makePermalinkFromTitle(carMake)}/${makePermalinkFromTitle(carModel)}/${year}/`);
        } else {
            vm.permalink(`/db/${makePermalinkFromTitle(tagType)}/${makePermalinkFromTitle(tag.name)}/`);
        }
        if (vm.description() === '') {
            vm.description(tag.description);
        }
        vm.permalinkBehavior(1);
        this.clearOtherTabs('tagHub');
        vm.convertedToTagHub(true);
        // must detect the change here, so reset
        vm.listingPageConfigType('');
        // nexttick
        setTimeout(() => vm.listingPageConfigType('tagHub'), 0);
    }

    public set_hasShownHubConfigurationPopup(hasShown: boolean)
    {
        this.getTemplateViewModel().hasShownHubConfigurationPopup(hasShown);
    }

    protected generatePermalink(title){

        let p = this.getTemplateViewModel().permalink();

        let config = this.getTemplateViewModel().listingPageConfigType();
        let permalink = '/' + title.toLowerCase().trim()
                .replace(/[^\w -]+/g, '')
                .replace(/[ _]+/g, '-')
                .replace(/-{2,}/g, '-')
                .replace(/-$/g, "")
            + '/';

        if (p == null || p == "" ) {
            if (config == HubPageConfig.VIDEO_CHANNEL) {
                permalink = `/channel${permalink}`;
            }
        } else {
            if (config == HubPageConfig.VIDEO_CHANNEL) {
                permalink = `/channel${permalink}`;
            }
        }

        this.getTemplateViewModel().permalink(permalink);
    }

    protected generateSlug(title){
        return title.toLowerCase().trim()
                .replace(/[^\w -]+/g, '')
                .replace(/[ _]+/g, '-')
                .replace(/-{2,}/g, '-')
                .replace(/-$/g, "");
    }

    protected onClickCancel(): void {
        this.caller.cancel();
    }

    protected onClickRemovePinnedTag( tag): void {

        let pinnedTags = this.getTemplateViewModel().pinnedTags();

        let newPinned = pinnedTags.filter((p) => p.id != tag.id);

        this.getTemplateViewModel().pinnedTags(newPinned);
    }

    protected onClickRemoveTagType(): void {

        this.getTemplateViewModel().tagType(null);

        this.tagTypeFilter.clearInput();
    }

    protected onClickRemovePinnedListingPage(listingPage): void {
        let pinnedLps = this.getTemplateViewModel().pinnedListingPages();

        let newPinned = pinnedLps.filter((p) => p.id != listingPage.id);

        this.getTemplateViewModel().pinnedListingPages(newPinned);
    }

    protected onClickRemovePinnedArticle(article): void {

        let pinnedArticles = this.getTemplateViewModel().pinnedArticles();

        let newPinned = pinnedArticles.filter((p) => p.reference != article.reference);

        this.getTemplateViewModel().pinnedArticles(newPinned);
    }

    public getPinnedTagIds(): Array<number> {
        let pinnedTags = this.getTemplateViewModel().pinnedTags();
        let ids: Array<number> = [];
        pinnedTags.forEach((p) => ids.push(p.id));

        return ids;
    }

    public setListingPage(listingPage, pinnedTags): void {
        this.getTemplateViewModel().id(listingPage.id);
        this.getTemplateViewModel().name(listingPage.name);
        this.getTemplateViewModel().permalink(listingPage.permalink);
        this.getTemplateViewModel().description(listingPage.description);
        this.tagTypeFilter.setOption(listingPage.tagType);
        this.getTemplateViewModel().tagType(listingPage.tagType);
        this.getTemplateViewModel().pinnedTagCard(listingPage.pinnedTag);
        this.getTemplateViewModel().listingPageConfigType(listingPage.config);
        this.getTemplateViewModel().originalListingPageConfigType(listingPage.config);
        this.typeSelector.setSelectedOption(listingPage.type);
        this.articleTypeSelector.setSelectedOption(listingPage.idArticleType);
        this.setSelectedTypeIsTrending();
        this.setSelectedFilterCategories(listingPage.categories);
        this.setPinnedTag(listingPage.pinnedTag);
        this.setSelectedFilterContentTypes(listingPage.contentTypes);
        this.setSelectedFilterSegments(listingPage.segments);
        this.setSelectedFilterArticleCharacteristics(listingPage.articleCharacteristics ? listingPage.articleCharacteristics : []);
        this.getTemplateViewModel().isNotDeletable(listingPage.isNotDeletable);
        if (this.isOfConfigType(HubPageConfig.TAG_HUB)) {
            this.set_hasShownHubConfigurationPopup(true);
            if(pinnedTags && pinnedTags.length > 0){
                let firstPinnedTag = pinnedTags[0];
                if (firstPinnedTag.idType && this.tagTypesRequiresArticleSubContent.indexOf(Number(firstPinnedTag.idType)) !== -1) {
                    this.getTemplateViewModel().showTagHubSubContent(true);
                }
            }
        }

        if (this.isHomePageHubPage(listingPage.config)) {
            this.setLockRadioPermalinks(true);
            this.setLockPermalinkInput(true);
            this.setLockRadioConfigType(true);
        }

        if (listingPage.config == 'channel') {
            this.setLockRadioPermalinks(true);
            this.setLockPermalinkInput(true);
            this.setLockRadioConfigType(true);
            this.channelFilter.getTemplateViewModel().optionObj(listingPage.channel);
        }

        if(listingPage.tagType != undefined) {
            this.tagTypeFilter.setOption(listingPage.tagType);
            let filters = listingPage.tagType.fields.filter(v => v.dataType == "text" || v.dataType == "date" || v.dataType == "tag" || v.dataType == "currency" || v.dataType == "number")
            let filter1Options = filters.map(v => ({name: v.label, id: v.id}));
            let specs = listingPage.tagType.fields.filter(v => v.dataType == "text" || v.dataType == "date" || v.dataType == "tag" || v.dataType == "currency" || v.dataType == "number" )
            let specToDisplay = specs.map(v => ({name: v.label, id: v.id}));
            filter1Options.unshift({name:"Select an option", id: null})
            specToDisplay.unshift({name:"No Spec Displayed", id: null})
            this.level1Filter.setOptions(filter1Options);
            this.specToDisplay.setOptions(specToDisplay);
            let level2Filters = listingPage.tagType.fields.filter(v => v.dataType == "text" || v.dataType == "date" || v.dataType == "tag" || v.dataType == "currency" || v.dataType == "number");
            let filterOneOption = null;
            let filterTwoOption = null;
            for (let filter of listingPage.filters) {
                let field = listingPage.tagType.fields.find(el => el.id == filter.idField)
                if (field) {

                    if (field) {
                        if (filter.level == 1) {
                            filterOneOption = field.id;
                            this.level1Filter.setSelectedOption(field.id);
                            level2Filters = level2Filters.filter(function (obj) {
                                return obj.id !== field.id;
                            });
                        } else {
                            filterTwoOption = field.id;
                        }
                    }
                }
            }

            let filter2Options = level2Filters.map(v => ({name: v.label, id: v.id}));
            filter2Options.unshift({name:"Select an option", id: null})
            this.level2Filter.setOptions(filter2Options);
            this.level2Filter.setSelectedOption(filterTwoOption);
            this.getTemplateViewModel().showSpecToDisplay(true);
            // this.setIsNotDeletable(listingPage.isNotDeletable);
        }

        let embedHTML = listingPage.embed;
        if(embedHTML){

            const embed = document.createElement('div');
            embed.innerHTML = embedHTML;

            const embedderPreview = document.getElementById('embedder-preview');

            embedderPreview.innerHTML = "";

            embedderPreview.appendChild(embed);
            this.setEmbedHTML(embedHTML);
        }
    }

    public setTagHubTagErrors(errors) {

        if (errors == null || errors.length == 0) {
            return;
        }

        let realErrors = {
            image: [],
            bannerImage: [],
            description: [],
            video: [],
            specs: [],
        };

        if (errors[0]) {
            errors = errors[0];
        }

        errors.messages.map((message) => {
            if (message.indexOf('banner image') !== -1) {
                realErrors.bannerImage = [message];
                this.getTemplateViewModel().isNewTagHubPopupErrorsVisible(true);
            } else if (message.indexOf('image') !== -1) {
                realErrors.image = [message];
                this.getTemplateViewModel().isNewTagHubPopupErrorsVisible(true);
            } else if (message.indexOf('description') !== -1) {
                realErrors.description = [message];
                this.getTemplateViewModel().isNewTagHubPopupErrorsVisible(true);
            } else if (message.indexOf('video') !== -1) {
                realErrors.video = [message];
                this.getTemplateViewModel().isNewTagHubPopupErrorsVisible(true);
            } else {
                // specs may come through more than once, so spread each set of errors in.
                realErrors.specs = [...realErrors.specs, message];
                this.getTemplateViewModel().isNewTagHubPopupErrorsVisible(true);
            }
        });

        this.getTemplateViewModel().tagHubTagErrors(realErrors);
    }

    public setDisplayField(listingPage){

        if(listingPage && listingPage.displayField){
            let displayField = listingPage.displayField;
            let filters = listingPage.tagType.fields.filter(v => v.dataType == "text" || v.dataType == "date" || v.dataType == "tag" || v.dataType == "currency" || v.dataType == "number")
            let displayFieldOptions = filters.map(v => ({name: v.label, id: v.id}));
            for(let filter of displayFieldOptions ){
                if(filter.id == displayField.id){
                    this.specToDisplay.setSelectedOption(filter.id);
                }
            }
            this.getTemplateViewModel().specToDisplayAscDesc(listingPage.type);
            this.getTemplateViewModel().showSpecToDisplay(true);
            this.getTemplateViewModel().onSelectOrder(true);
        }
    }

    public onSelectSpecificationFilter(data,event){
        if(this.level1Filter.getTemplateViewModel().selectedOption()){
            this.getTemplateViewModel().showSpecToDisplay(true);
        }
    }
    public onSelectDisplaySpec(data,event){
        if(this.specToDisplay.getTemplateViewModel().selectedOption()){
            this.getTemplateViewModel().onSelectOrder(true);
            this.getTemplateViewModel().specToDisplayAscDesc("Asc");
        }
        if(this.specToDisplay.getTemplateViewModel().selectedOption() == null){
            this.getTemplateViewModel().onSelectOrder(false);
        }
    }

    public setPermalinkBehavior(isResolvable, permalinkListingPage){
        if(permalinkListingPage != null){
            this.getTemplateViewModel().permalinkBehavior("3");
            this.listingPagePermalinkFilter.getTemplateViewModel().listingPageObj(permalinkListingPage);
            this.listingPagePermalinkFilter.getTemplateViewModel().listingPage(permalinkListingPage.name + ' (' + permalinkListingPage.permalink + ')');
            this.listingPagePermalinkFilter.getTemplateViewModel().idListingPage(permalinkListingPage.id);
            let closeBtn = document.getElementById(this.listingPagePermalinkFilter.getButtonCloseElementId());
            if (!closeBtn.classList.contains('is-showing')) {
                closeBtn.classList.add('is-showing');
            }
        }else{
            this.getTemplateViewModel().permalinkBehavior(isResolvable ? "1" : "2");
        }
    }

    public setListingPageInterlinkEnabled(listingPageInterlinkEnabled){
        this.getTemplateViewModel().listingPageInterlinkEnabled(listingPageInterlinkEnabled);
    }

    public getImagePickerTarget(){
        return this.getTemplateViewModel().imagePickerTarget();
    }

    public setImagePickerTarget(imagePickerTarget)
    {
        this.getTemplateViewModel().imagePickerTarget(imagePickerTarget);
    }

    public setRandomizePinnedArticles(randomizePinnedArticles){
        this.getTemplateViewModel().randomizePinnedArticles(randomizePinnedArticles);
    }

    public setPinnedArticlesEnabled(pinnedArticlesEnabled){
        this.getTemplateViewModel().pinnedArticlesEnabled(pinnedArticlesEnabled);
    }

    public setLayoutOptions(layoutOptions){


        for(let option of layoutOptions){

            let layoutTooltip = new infoButton_template('layoutTooltip' + option.name, this.getTemplateViewModel(), this.caller);
            //writerCommissionHeaderTooltipBtn.setTitle('commission');
            layoutTooltip.setContent(option.tooltipContent);
            option.tooltip = layoutTooltip;
        }

        this.getTemplateViewModel().layoutOptions(layoutOptions);
    }

    public setIdLayout(idLayout){
        this.getTemplateViewModel().idLayout(idLayout);
    }

    public setTagHubTagTypeRestrictions(tagHubTagTypeRestrictions){
        this.getTemplateViewModel().tagHubTagTypeRestrictions(tagHubTagTypeRestrictions);
    }

    public setIsTagHubEnabled(isTagHubEnabled){
        this.getTemplateViewModel().isTagHubEnabled(isTagHubEnabled);
    }

    public getTagHubTagTypeRestrictions(){
        return this.getTemplateViewModel().tagHubTagTypeRestrictions();
    }

    protected setTagFilter(tags, idElement): void  {

        switch (idElement) {
            case 'inclusionRuleTagFilter':
                this.inclusionRules.setTags(tags);
                break;
            case 'tagHubTagFilter':
                this.tagHubTagFilter.setTags(tags);
            default:
                this.getTemplateViewModel().tagFilter.tags(tags);
                break;
        }
    }

    public setTagTypeFields(fields): void {

        this.inclusionRules.setTagTypeFields(fields);
    }

    public setInclusionRulesFields(inclusionRules): void {
        this.inclusionRules.setInclusionRules(inclusionRules);
    }

    protected setTagTypes(tagTypes): void  {

        this.tagTypeFilter.setOptions(tagTypes);
    }

    public setSelectedTagType(tagType){

        this.getTemplateViewModel().tagType(tagType);
        let filters = tagType.fields.filter(v => v.dataType != "tags")
        let filterOptions = filters.map(v => ({ name: v.label, id: v.id }));
        filterOptions.unshift({name: 'Select an option', id: null});

        let specs = tagType.fields.filter(v => v.dataType == "text" || v.dataType == "date" || v.dataType == "tag" || v.dataType == "currency" || v.dataType == "number")
        let specToDisplay = specs.map(v => ({name: v.label, id: v.id}));
        specToDisplay.unshift({name:"No Spec Displayed", id: null})

        this.level1Filter.setOptions(filterOptions);
        this.level2Filter.setOptions(filterOptions);
        this.specToDisplay.setOptions(specToDisplay);
    }

    public setTypes(types): void {

        this.typeSelector.setOptions(types);
        this.sortOrderTypes = types;
    }

    public setArticleTypes(articleTypes): void {
        this.articleTypeSelector.setOptions(articleTypes);
    }

    public setPinnedTags(tags): void {

        this.getTemplateViewModel().pinnedTags(tags);
        if (this.getTemplateViewModel().isHub()) {
            this.tagHubTagFilter.setTag(tags[0]);
        }
    }

    public setIsNotDeletable(isNotDeletable: boolean)
    {
        this.getTemplateViewModel().isNotDeletable(isNotDeletable);
        const self = this;
        setTimeout(() => self.disableFieldsForNotDeletableListingPage(), 0);
    }

    protected disableFieldsForNotDeletableListingPage()
    {
        const isNotDeletable = this.getTemplateViewModel().isNotDeletable();

        this.typeSelector.setDisable(isNotDeletable);
        this.filterArticleCharacteristics.setIsDisabled(isNotDeletable);
        this.articleTypeSelector.setDisable(isNotDeletable);
        this.filterContentType.setIsDisabled(isNotDeletable);
        this.filterSegments.setIsDisabled(isNotDeletable);
        this.tagFilter.setIsDisabled(isNotDeletable);
        this.filterCategory.setIsDisabled(isNotDeletable);
    }

    public addTagType(): void {

        let tagTypeObj = this.tagTypeFilter.getTemplateViewModel().tagTypeObj();

        if (tagTypeObj != "") {

            this.getTemplateViewModel().tagType(tagTypeObj);
            this.getTemplateViewModel().filters(tagTypeObj.fields)
        }

    }

    public addPinnedTag(): void {

        let pinnedTags = (this.getTemplateViewModel().pinnedTags());
        let tagObj = this.tagFilter.getTemplateViewModel().tagObj();

        if (tagObj != "") {

            let found = pinnedTags.find((lp) => lp.id == tagObj.id);
            if (found == undefined) {
                if(tagObj.tagType != null){
                    tagObj.type = {
                        name: tagObj.formattedTagTypeAndDataset
                    };
                } else {
                    tagObj.type = null;
                }
                pinnedTags.push(tagObj);
                this.getTemplateViewModel().pinnedTags(pinnedTags);
            } else {
                this.caller.triggerWarningNotification('Tag already pinned');
            }
        }

        this.tagFilter.clearInput();
    }

    public clearMessages(): void {

        this.validationsList.clearMessages();
    }

    public setLevel2Filters() {

        let selectedFilter1 = this.level1Filter.getTemplateViewModel().selectedOption();
        let filters = this.level1Filter.getTemplateViewModel().options();
        if (selectedFilter1 != null) {

            filters = filters.filter( el => el.id != selectedFilter1);
        }
        this.level2Filter.setOptions(filters);
    }

    public onChangeSelectFilterLevel2() {

        let selectedFilter = this.getTemplateViewModel().idLevel2Filter();
        let filtersLvl2 = this.getTemplateViewModel().selectedLvl2Filters();

        let filter = this.getTemplateViewModel().filters().find( el => el.id == selectedFilter);
        if(filter) {
            if(!filtersLvl2.find( el => el.id == filter.id)){
                filtersLvl2.push(filter);
            }
        }
        this.getTemplateViewModel().selectedLvl2Filters([]);
        this.getTemplateViewModel().selectedLvl2Filters(filtersLvl2);
        this.getTemplateViewModel().idLevel2Filter(null);
    }

    /**
     * Sets the embed html, and if there is response data supplied, it's parsed for EmbedInfo data,
     * then forwarded along to the processContentEmbed function in embedHelper.
     *
     * @param embedHtml
     * @param responseData
     */
    public async setEmbedHTML(embedHtml: string, responseData = null){

        if (responseData) {
            let embedData: EmbedInfo = {
                id: !!responseData.id? responseData.id : null,
                name: responseData.name,
                embed: responseData.embed,
                script: !!responseData.script? responseData.script : null,
                html: responseData.html,
            }
            embedHtml = await this.caller.embedHelper.processContentEmbed(embedData);
            this.getTemplateViewModel().embedHTML(embedHtml);
        } else {
            this.getTemplateViewModel().embedHTML(embedHtml);
        }
    }

    public onClickRemoveEmbed(){

        this.getTemplateViewModel().embedHTML(null);
        document.getElementById('embedder-preview').innerHTML = "";
    }

    public setIdBrand(idBrand){

        this.getTemplateViewModel().idBrand(idBrand);
    }

    public handleInclusionRules(idElement: string): void {
        this.inclusionRules.handleState(idElement);
    }

    public getInclusionRuleFieldOptionId() {

        return this.inclusionRules.getSelectedFieldOptionId();
    }

    public removeValidationClass() {

        document.body.classList.remove('_form-sub');
    }

    public setSelectedTypeIsTrending(){
        let selectedType = this.typeSelector.getTemplateViewModel().selectedOption();
        let isTrending = (selectedType == "trending");

        if(!isTrending){
            this.getTemplateViewModel().randomizePinnedArticles(false);
        }

        this.getTemplateViewModel().selectedTypeIsTrending(isTrending);
    }

    public updatePositions(){

        let pinnedArticles = this.getTemplateViewModel().pinnedArticles();

        for (let i = 0; i < pinnedArticles.length; i++) {

            pinnedArticles[i].position = i + 1;
        }
        this.getTemplateViewModel().pinnedArticles([]);
        this.getTemplateViewModel().pinnedArticles(pinnedArticles);
    }

    public setPinnedArticles(articles){

        let data = [];

        for (let article of articles){

            let pinnedArticle : pinnedArticle = {

                id:             '',
                idArticle:      article.article.id,
                reference:      article.reference,
                article:        article.article,
                alternateTitle: article.alternateTitle ? article.alternateTitle : '',
                pinnedHours:    '',
                position:       article.position ? article.position: '',
                expire:         article.expiry,
                timeLeft:       article.timeLeft,
                enableEdit:     false,
            }

            data.push(pinnedArticle)
        }

        this.pinnedArticles.setArticles(data)
    }

    public getPinnedArticles(){

        let data = [];
        let articles = this.pinnedArticles.getArticles();
        for (let item of articles){

            let pinnedArticle = {

                title:           item.article.title,
                reference:       item.reference,
                timeLeft:        item.timeLeft,
                expiry:          item.expire,
                pinnedHours:     item.pinnedHours,
                alternateTitle:  item.alternateTitle,
                position:        item.position,
            };

            data.push(pinnedArticle)
        }

        //keep only the selected layout required
        let max = this.pinnedArticles.getTemplateViewModel().maximum();
        data = data.slice(0,max);

        return data;
    }

    protected setArticleFilterAutocomplete(articles): void  {

        this.pinnedArticles.articleFilter.setOptions(articles);
    }

    protected setSubContentArticlesFilterAutocomplete(articles): void  {

        this.subContentArticlesFilter.setOptions(articles);
    }

    public setPinnedListingPages(listingPages){

        let data = [];
        for(let x in listingPages){

            if (!listingPages[x].listingPage) continue;

            let uuid = `${this.pinnedListingPages.idElement}_filterShowMoreListingPage${x}`;
            let filter = new filterListingPage_template(uuid, this.getTemplateViewModel(), this.caller);
            filter.setShowDetails(true);
            filter.setPlaceholder('Show More Listing Page');

            let pinnedListingPage : HubPagePinnedHubPage = {
                uuid:                        uuid,
                id:                         listingPages[x].id ? listingPages[x].id : '',
                idListingPage:              listingPages[x].idListingPage,
                listingPage:                listingPages[x].listingPage,
                idShowMoreListingPage:      listingPages[x].idShowMoreListingPage,
                showMoreListingPage:        listingPages[x].showMoreListingPage,
                showMoreListingPageFilter:  filter,
                position:                   listingPages[x].position,
                dateCreated:                listingPages[x].dateCreated ? listingPages[x].dateCreated : '',
                alternateTitle:             listingPages[x].alternateTitle,
                enableEdit:                 false,
                pinnedSection:              listingPages[x].pinnedSection,
            }

            if(listingPages[x].showMoreListingPage){

                let showMoreListingPage = listingPages[x].showMoreListingPage;
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPageObj(showMoreListingPage);
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPage(showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')');
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().idListingPage(listingPages[x].idShowMoreListingPage);
            }

            data.push(pinnedListingPage)
        }

        this.pinnedListingPages.setListingPages(data)
    }

    public setSecondaryPinnedListingPages(listingPages, startIndexForUuid){

        let data = [];
        for(let x in listingPages){

            if (!listingPages[x].listingPage) continue;
            let uuid = `${this.secondaryPinnedListingPages.idElement}_secondaryFilterShowMoreListingPage${startIndexForUuid}`;
            let filter = new filterListingPage_template(uuid, this.getTemplateViewModel(), this.caller);
            filter.setShowDetails(true);
            filter.setPlaceholder('Show More Listing Page');

            let pinnedListingPage : HubPagePinnedHubPage = {

                uuid:                       uuid,
                id:                         listingPages[x].id ? listingPages[x].id : '',
                idListingPage:              listingPages[x].idListingPage,
                listingPage:                listingPages[x].listingPage,
                idShowMoreListingPage:      listingPages[x].idShowMoreListingPage,
                showMoreListingPage:        listingPages[x].showMoreListingPage,
                showMoreListingPageFilter:  filter,
                position:                   listingPages[x].position,
                dateCreated:                listingPages[x].dateCreated ? listingPages[x].dateCreated : '',
                alternateTitle:             listingPages[x].alternateTitle,
                enableEdit:                 false,
                pinnedSection:              listingPages[x].pinnedSection
            }

            if(listingPages[x].showMoreListingPage){

                let showMoreListingPage = listingPages[x].showMoreListingPage;
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPageObj(showMoreListingPage);
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().listingPage(showMoreListingPage.name + ' (' + showMoreListingPage.permalink + ')');
                pinnedListingPage.showMoreListingPageFilter.getTemplateViewModel().idListingPage(listingPages[x].idShowMoreListingPage);
            }

            data.push(pinnedListingPage);

            startIndexForUuid++;
        }

        this.secondaryPinnedListingPages.setListingPages(data);
    }

    public getPinnedListingPages(){

        let pinnedListingPageIds = [];
        let listingPages = this.pinnedListingPages.getListingPages();

        for (let i = 0; i < listingPages.length; i++) {

            let item = {

                idListingPage: listingPages[i].idListingPage,
                idShowMoreListingPage: listingPages[i].showMoreListingPageFilter.getTemplateViewModel().idListingPage(),
                alternateTitle : listingPages[i].alternateTitle,
                position :  listingPages[i].position,
                pinnedSection: HubPagePinnedHubPageSection.PRIMARY,
            }

            pinnedListingPageIds.push(item)
        }

        if (this.isOfConfigType(HubPageConfig.HOMEPAGE_VIDEO) || this.isOfConfigType(HubPageConfig.HOMEPAGE_THREAD)) {

            let secondaryListingPages = this.secondaryPinnedListingPages.getListingPages();
            for (let i = 0; i < secondaryListingPages.length; i++) {

                let item = {

                    idListingPage: secondaryListingPages[i].idListingPage,
                    idShowMoreListingPage: secondaryListingPages[i].showMoreListingPageFilter.getTemplateViewModel().idListingPage(),
                    alternateTitle : secondaryListingPages[i].alternateTitle,
                    position :  secondaryListingPages[i].position,
                    pinnedSection: HubPagePinnedHubPageSection.SECONDARY,
                }

                pinnedListingPageIds.push(item)
            }
        }

        return  pinnedListingPageIds;
    }

    public setFilterListingPagesAutoComplete(listingPages: Array<HubPageSearchResult>, listingPageIdElement: string): void {

        if (listingPageIdElement.startsWith('pinnedListingPages')) {
            if (listingPageIdElement.includes('filterShowMoreListingPage')) {
                if (listingPageIdElement == 'pinnedListingPages_filterShowMoreListingPage') {
                    this.pinnedListingPages.showMoreListingPageFilter.setOptions(listingPages);
                } else {
                    let hubPages = this.pinnedListingPages.getListingPages();
                    hubPages.forEach((item: HubPagePinnedHubPage  ) => {
                        if (item.uuid == listingPageIdElement) {
                            item.showMoreListingPageFilter.setOptions(listingPages);
                        }
                    });
                }
            } else {
                this.pinnedListingPages.listingPageFilter.setOptions(listingPages);
            }
        } else if (listingPageIdElement.startsWith('secondaryPinnedListingPages')) {
            if (listingPageIdElement.includes('secondaryFilterShowMoreListingPage')) {
                if (listingPageIdElement == 'secondaryPinnedListingPages_secondaryFilterShowMoreListingPage') {
                    this.secondaryPinnedListingPages.showMoreListingPageFilter.setOptions(listingPages);
                } else {
                    let hubPages = this.secondaryPinnedListingPages.getListingPages();
                    hubPages.forEach((item: HubPagePinnedHubPage  ) => {
                        if (item.uuid == listingPageIdElement) {
                            item.showMoreListingPageFilter.setOptions(listingPages);
                        }
                    });
                }
            } else {

                this.secondaryPinnedListingPages.listingPageFilter.setOptions(listingPages);
            }
        } else if (listingPageIdElement == 'filterPermalinkListingPage') {
            this.listingPagePermalinkFilter.setOptions(listingPages);
        } else {
            this.pinnedListingPages.filterSimpleOnAutoComplete(listingPages, listingPageIdElement);
        }
    }

    public updatePinnedArticleMaximumNumber(){

        let layoutOptions = this.getTemplateViewModel().layoutOptions();
        let idLayout = this.getTemplateViewModel().idLayout();

        let index = layoutOptions.findIndex(layoutOption => layoutOption.id == idLayout);
        if(index > -1){

            let layoutOption = layoutOptions[index];
            let number = layoutOption.primaryArticleCount + layoutOption.secondaryArticleCount;
            this.pinnedArticles.setMaximum(number)
        }
    }

    protected clearOtherTabs(newTab) {

        this.filterLayoutOptions();
        if (newTab == 'none' || newTab == 'tagHub') {
            this.clearArticlesTab();
            this.clearTagsTab();
        } else if (newTab == 'articles') {
            this.clearTagsTab();
        } else if (newTab == 'tags') {
            this.clearArticlesTab();
            this.clearSharedTab();
            this.clearTagHubTab();
        } else if (newTab == 'homepage_video' || newTab == 'homepage_thread' || newTab == 'channel') {
            this.clearSharedTab();
            this.clearTagsTab();
            this.clearArticlesTab();
            this.clearTagHubTab();
        }

        this.clearHomePageHubPageTab(newTab);

        if (this.getTemplateViewModel().originalListingPageConfigType() == 'tagHub' && newTab != 'tagHub') {
            this.getTemplateViewModel().isNotDeletable(false);
        }
    }

    protected clearTagsTab() {

        this.tagTypeFilter.clearInput();
        this.level1Filter.setSelectedOption(null);
        this.level2Filter.setSelectedOption(null);
        this.inclusionRules.reset();
    }

    protected clearTagHubTab()
    {
        this.subContentArticles.clearArticles();
    }


    private clearArticlesTab() {

        this.typeSelector.setSelectedOption(this.sortOrderTypes[0].id); // set to the first option
        this.getTemplateViewModel().selectedContentTypes([]);
        this.getTemplateViewModel().selectedArticleCharacteristics([]);
        if (this.getTemplateViewModel().listingPageConfigType != 'tagHub') {
            this.getTemplateViewModel().pinnedTags([]);
        }
        this.getTemplateViewModel().selectedCategories([]);
        this.getTemplateViewModel().listingPageInterlinkEnabled(false);
        this.getTemplateViewModel().randomizePinnedArticles(false);
        this.subContentArticles.clearArticles();

    }

    private clearHomePageHubPageTab(homePageTab: string) {

        let isHomePageVideosTab = (homePageTab == 'homepage_video');
        let isHomePageThreadsTab = (homePageTab == 'homepage_thread');
        let isChannel = (homePageTab == 'channel');

        let articleTypeSelection = null;
        if (isHomePageVideosTab) {
            articleTypeSelection = 15;
            this.getTemplateViewModel().permalink('/videos/');
            this.getTemplateViewModel().idLayout(null);
            this.typeSelector.setSelectedOption('trending');
            this.getTemplateViewModel().pinnedArticlesEnabled(false);
        } else {
            if (isHomePageThreadsTab) {
                articleTypeSelection = 16;
                let layoutOptions = this.getTemplateViewModel().layoutOptions();

                let layout = layoutOptions.find(l => l.wrappingClass == 'featured-9-pin-autoscroll');

                this.getTemplateViewModel().permalink('/threads/');
                this.getTemplateViewModel().idLayout(layout.id);
                this.typeSelector.setSelectedOption('trending');
                this.getTemplateViewModel().pinnedArticlesEnabled(true);
            }
            if (isChannel) {
                articleTypeSelection = 15;
                let layoutOptions = this.getTemplateViewModel().layoutOptions();

                let layout = layoutOptions.find(l => l.wrappingClass == 'featured-3-pin-autoplay');

                this.getTemplateViewModel().activeLayoutOptions([layout]);
                let permalink = this.getTemplateViewModel().permalink();
                if (!permalink) {
                    this.getTemplateViewModel().permalink('/channel/');
                }
                this.getTemplateViewModel().idLayout(layout.id);
                this.typeSelector.setSelectedOption('latest');
                this.getTemplateViewModel().pinnedArticlesEnabled(false);
                this.getTemplateViewModel().pinnedTag(null);
            }
        }
        // this.getTemplateViewModel().permalinkBehavior('0');
        this.typeSelector.setDisable(isHomePageVideosTab || isHomePageThreadsTab || isChannel);
        this.filterArticleCharacteristics.setSelectedItems([]);
        this.filterArticleCharacteristics.setIsDisabled(isHomePageVideosTab || isHomePageThreadsTab || isChannel);
        this.filterContentType.setSelectedItems([]);
        this.filterContentType.setIsDisabled(isHomePageVideosTab || isHomePageThreadsTab ||isChannel);
        this.filterSegments.setSelectedItems([]);
        this.filterSegments.setIsDisabled(isHomePageVideosTab || isHomePageThreadsTab || isChannel);
        this.articleTypeSelector.setSelectedOption(articleTypeSelection);
        this.articleTypeSelector.setDisable(isHomePageVideosTab || isHomePageThreadsTab || isChannel);
        this.filterCategory.setSelectedItems([]);
    }

    private clearSharedTab() {
        this.getTemplateViewModel().pinnedArticlesEnabled(false);
        this.getTemplateViewModel().activeLayoutOptions([]);
        this.getTemplateViewModel().idLayout(1);
        this.pinnedArticles.clearInput();
        this.pinnedArticles.setArticles([]);
        this.tagFilter.clearInput();
        this.setPinnedTags([]);
        this.getTemplateViewModel().pinnedArticlesEnabled(false);
        this.pinnedListingPages.clearInput();
        this.pinnedListingPages.setListingPages([]);
        this.secondaryPinnedListingPages.setListingPages([]);
    }
    public showTagPicker(mode, target) {

        this.tagPicker.setMode(mode);
        this.caller.initializeCkEditors();
        this.tagPicker.setTarget(target);
        this.tagPicker.show();
    }

    public initTagPickerCkEditors(): void{

        this.tagPicker.initializeCkEditors();
    }

    public onClickSelectPinnedTag() {
        this.caller.getTagData();
        this.showTagPicker('single-select', 'pinnedTag')
    }

    public onClickPinnedTagEdit() {

        let item = this.getTemplateViewModel().pinnedTag();
        let itemElement = item.source;
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = itemElement;
        let element = tempDiv.firstChild;

        // reorder specs..
        let tagInsertedFields  = this.getTagElementInsertedFieldsInOrder(element);
        this.setTagGroupTagElements([tagInsertedFields]);

        this.caller.getTagData();
        this.showTagPicker('single-select', 'pinnedTag');
        this.tagPicker.editTagElement(element);
        this.tagPicker.getOnlickView(item);
    }

    public setTagGroupTagElements(elements) {
        this.tagPicker.setTagGroupTagElements(elements);
    }

    public getTagElementInsertedFieldsInOrder(element) {
        return this.tagPicker.getTagElementInsertedFieldsInOrder(element);
    }

    public onClickPinnedTagDelete() {

        this.getTemplateViewModel().pinnedTag(null);
    }

    public convertStringToHtmlDoc(htmlString) {

        let div = document.createElement('div');
        div.innerHTML = htmlString.trim();
        return div.firstChild;
    }

    public addTagPickerValidationClass() {

        document.body.classList.add('_tagpicker')
    }

    public removeTagPickerValidationClass() {

        document.body.classList.remove('_tagpicker')
    }

    public setPinnedTag(tagElement) {

        this.getTemplateViewModel().pinnedTag(tagElement);
        var pinnedTagDiv = document.getElementById("pinnedTagDiv");

        if (pinnedTagDiv && tagElement && tagElement.source) {
            pinnedTagDiv.innerHTML = tagElement.source;
        }
    }

    public onClickSelectAsPinned(data) {

        if (data.specs && data.specs.length !== 0) {
            for (var i = 0; i < data.specs.length; i++) {
                data.specs[i].selected = true;
            }
        }
        let newTagElement = this.caller.buildTagElement(data);
        let tag = {"source": newTagElement};
        let tagInfo = {"block": tag, "tagObject": [data], "isVersusStyle": false};

        this.getTemplateViewModel().pinnedTag(tagInfo);
    }

    public setPermissions(permissions) {

        this.getTemplateViewModel().permissions(permissions);
        this.tagPicker.setPermissions(permissions);
        this.videoPickerHelper.setPermissions(permissions);
    }

    // public showImagePicker(mode,target, keyword = null){

    //     this.imagePicker.setMode(mode);
    //     this.setImagePickerTarget(target);
    //     this.imagePicker.setTarget(target);
    //     this.caller.getImageData(keyword);
    //     this.caller.getGalleryData();
    //     this.imagePicker.show();
    // }

    // public editImage(target, viewMode){
    //     this.showImagePicker(viewMode, target);
    //     let image = null

    //     if(target == 'thumbnail_image'){
    //         image = this.imageWidgetForThumbnailImage.getImage();
    //     }

    //     if(target == 'alternate_image'){
    //         image = this.imageWidgetForAlternateImage.getImage();
    //     }

    //     if(target == 'featured_image' || target == 'featured_image_embed'){
    //         image = this.imageWidgetForFeaturedImage.getImage();
    //     }

    //     this.imagePicker.editImage(image);

    // }

    public handleTagInArticle(target: string): void {

        switch(target) {
            case 'tag_picker_edit_cancel':

                //this.caller.clearValidationErrors();
                this.removeTagPickerValidationClass();
                this.tagPicker.tagEdit.hide();
                break;
            case 'tag_picker_edit':

                this.tagPicker.tagEdit.setTag(this.caller.getTagToEdit());
                this.tagPicker.tagEdit.show();
                break;
        }
    }

    public setCategories(categories): void {

        this.filterCategory.setItems(categories);
    }

    public setSelectedFilterCategories(categoriesId): void{

        let selectedCategories = [];

        this.filterCategory.getItems().forEach((c) => {
            if (categoriesId.indexOf(c.id) !== -1) {
                selectedCategories.push(c);
            }
        })

        this.getTemplateViewModel().selectedCategories(selectedCategories);
        this.filterCategory.setSelectedItems(selectedCategories);
    }

    public updateSelectedCategories() {


        let selectedFilterCategories = this.filterCategory.getSelectedItems();
        let categories = this.filterCategory.getItems();

        let categoryList = [];
        //build list of the categories that are now selected in the filter
        for (let idCategory of selectedFilterCategories) {

            let category = categories.find(c => c.id == idCategory);
            if (category) {

                categoryList.push(category);
            }

        }

        let selectedCats = this.getTemplateViewModel().selectedCategories();

        //add categories that have not yet been selected
        for (let cat of categoryList) {

            let existingCategory = selectedCats.find(c => c.id == cat.id);

            if (!existingCategory) {
                selectedCats.push(cat);
            }
        }

        for (let i = selectedCats.length - 1; i >= 0; i--) {

            let catToRemove = categoryList.find(c => c.id == selectedCats[i].id);
            if (!catToRemove) {
                selectedCats.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedCategories([]);
        this.getTemplateViewModel().selectedCategories(selectedCats);
    }

    protected onClickDeleteSelectedCategory(data) {

        let allCategories = this.filterCategory.getItems();
        let selectedCategories = this.getTemplateViewModel().selectedCategories();
        let index = selectedCategories.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedCategories.splice(index, 1);
        }

        this.getTemplateViewModel().selectedCategories(selectedCategories);

        let selectedFilterCategories = this.filterCategory.getSelectedItems();

        index = selectedFilterCategories.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterCategories.splice(index, 1);
        }

        let updatedCats = [];
        for (let idCat of selectedFilterCategories) {

            let cat = allCategories.find(c => c.id == idCat);
            if (cat) {
                updatedCats.push(cat);
            }
        }

        this.filterCategory.setSelectedItems(updatedCats);

    }

    public setContentTypes(contentTypes): void {

        this.filterContentType.setItems(contentTypes);
    }

    public setArticleCharacteristics(articleCharacteristics): void {
        this.filterArticleCharacteristics.setItems(articleCharacteristics);
    }

    public setSelectedFilterContentTypes(contentTypesId): void{

        let selectedContentTypes = [];

        this.filterContentType.getItems().forEach((c) => {
            if (contentTypesId.indexOf(c.id) !== -1) {
                selectedContentTypes.push(c);
            }
        })

        this.getTemplateViewModel().selectedContentTypes(selectedContentTypes);
        this.filterContentType.setSelectedItems(selectedContentTypes);
    }

    public updateSelectedContentTypes() {


        let selectedFilterContentTypes = this.filterContentType.getSelectedItems();
        let contentTypes = this.filterContentType.getItems();

        let contentTypeList = [];
        //build list of the contentTypes that are now selected in the filter
        for (let idContentType of selectedFilterContentTypes) {

            let contentType = contentTypes.find(c => c.id == idContentType);
            if (contentType) {

                contentTypeList.push(contentType);
            }

        }

        let selectedContentTypes = this.getTemplateViewModel().selectedContentTypes();

        //add contentTypes that have not yet been selected
        for (let ct of contentTypeList) {

            let existingContentType = selectedContentTypes.find(c => c.id == ct.id);

            if (!existingContentType) {
                selectedContentTypes.push(ct);
            }
        }

        for (let i = selectedContentTypes.length - 1; i >= 0; i--) {

            let contentTypeToRemove = contentTypeList.find(c => c.id == selectedContentTypes[i].id);
            if (!contentTypeToRemove) {
                selectedContentTypes.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedContentTypes([]);
        this.getTemplateViewModel().selectedContentTypes(selectedContentTypes);
    }

    protected onClickDeleteSelectedContentType(data) {

        let allContentTypes = this.filterContentType.getItems();
        let selectedContentTypes = this.getTemplateViewModel().selectedContentTypes();
        let index = selectedContentTypes.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedContentTypes.splice(index, 1);
        }

        this.getTemplateViewModel().selectedContentTypes(selectedContentTypes);

        let selectedFilterContentTypes = this.filterContentType.getSelectedItems();

        index = selectedFilterContentTypes.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterContentTypes.splice(index, 1);
        }

        let updatedContentTypes = [];
        for (let idCat of selectedFilterContentTypes) {

            let ct = allContentTypes.find(c => c.id == idCat);
            if (ct) {
                updatedContentTypes.push(ct);
            }
        }

        this.filterContentType.setSelectedItems(updatedContentTypes);

    }



    public setSegments(segments): void {

        this.filterSegments.setItems(segments);
    }

    public setSelectedFilterSegments(segmentsId): void{

        let selectedSegments = [];

        this.filterSegments.getItems().forEach((c) => {
            if (segmentsId.indexOf(c.id) !== -1) {
                selectedSegments.push(c);
            }
        })

        this.getTemplateViewModel().selectedSegments(selectedSegments);
        this.filterSegments.setSelectedItems(selectedSegments);
    }

    public updateSelectedSegments() {


        let selectedFilterSegments = this.filterSegments.getSelectedItems();
        let segments = this.filterSegments.getItems();

        let segmentList = [];
        //build list of the contentTypes that are now selected in the filter
        for (let idSegment of selectedFilterSegments) {

            let segment = segments.find(c => c.id == idSegment);
            if (segment) {

                segmentList.push(segment);
            }

        }

        let selectedSegments = this.getTemplateViewModel().selectedSegments();

        //add contentTypes that have not yet been selected
        for (let ct of segmentList) {

            let existingContentType = selectedSegments.find(c => c.id == ct.id);

            if (!existingContentType) {
                selectedSegments.push(ct);
            }
        }

        for (let i = selectedSegments.length - 1; i >= 0; i--) {

            let contentTypeToRemove = segmentList.find(c => c.id == selectedSegments[i].id);
            if (!contentTypeToRemove) {
                selectedSegments.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedSegments([]);
        this.getTemplateViewModel().selectedSegments(selectedSegments);
    }

    protected onClickDeleteSelectedSegments(data) {

        let allSegments = this.filterSegments.getItems();
        let selectedSegments = this.getTemplateViewModel().selectedSegments();
        let index = selectedSegments.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedSegments.splice(index, 1);
        }

        this.getTemplateViewModel().selectedSegments(selectedSegments);

        let selectedFilterSegments = this.filterSegments.getSelectedItems();

        index = selectedFilterSegments.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterSegments.splice(index, 1);
        }

        let updatedSegments = [];
        for (let idCat of selectedFilterSegments) {

            let ct = allSegments.find(c => c.id == idCat);
            if (ct) {
                updatedSegments.push(ct);
            }
        }

        this.filterSegments.setSelectedItems(updatedSegments);

    }

    public setSelectedFilterArticleCharacteristics(articleCharacteristicsId): void{

        let selectedArticleCharacteristics = [];

        this.filterArticleCharacteristics.getItems().forEach((c) => {
            if (articleCharacteristicsId.indexOf(c.id) !== -1) {
                selectedArticleCharacteristics.push(c);
            }
        })

        this.getTemplateViewModel().selectedArticleCharacteristics(selectedArticleCharacteristics);
        this.filterArticleCharacteristics.setSelectedItems(selectedArticleCharacteristics);
    }

    public updateSelectedArticleCharacteristics() {


        let selectedFilterArticleCharacteristics = this.filterArticleCharacteristics.getSelectedItems();
        let articleCharacteristics = this.filterArticleCharacteristics.getItems();

        let articleCharacteristicsList = [];
        //build list of the articleCharacteristics that are now selected in the filter
        for (let idArticleCharacteristics of selectedFilterArticleCharacteristics) {

            let articleCharacteristic = articleCharacteristics.find(c => c.id == idArticleCharacteristics);
            if (articleCharacteristic) {

                articleCharacteristicsList.push(articleCharacteristic);
            }

        }

        let selectedArticleCharacteristics = this.getTemplateViewModel().selectedArticleCharacteristics();

        //add articleCharacteristics that have not yet been selected
        for (let ct of articleCharacteristicsList) {

            let existingArticleCharacteristics = selectedArticleCharacteristics.find(c => c.id == ct.id);

            if (!existingArticleCharacteristics) {
                selectedArticleCharacteristics.push(ct);
            }
        }

        for (let i = selectedArticleCharacteristics.length - 1; i >= 0; i--) {

            let articleCharacteristicsToRemove = articleCharacteristicsList.find(c => c.id == selectedArticleCharacteristics[i].id);
            if (!articleCharacteristicsToRemove) {
                selectedArticleCharacteristics.splice(i, 1);
            }
        }

        this.getTemplateViewModel().selectedArticleCharacteristics([]);
        this.getTemplateViewModel().selectedArticleCharacteristics(selectedArticleCharacteristics);
    }

    protected onClickDeleteSelectedArticleCharacteristics(data) {

        let allArticleCharacteristics = this.filterArticleCharacteristics.getItems();
        let selectedArticleCharacteristics = this.getTemplateViewModel().selectedArticleCharacteristics();
        let index = selectedArticleCharacteristics.findIndex(i => i.id == data.id);
        if (index != -1) {
            selectedArticleCharacteristics.splice(index, 1);
        }

        this.getTemplateViewModel().selectedArticleCharacteristics(selectedArticleCharacteristics);

        let selectedFilterArticleCharacteristics = this.filterArticleCharacteristics.getSelectedItems();

        index = selectedFilterArticleCharacteristics.findIndex(i => i == data.id);
        if (index != -1) {
            selectedFilterArticleCharacteristics.splice(index, 1);
        }

        let updatedArticleCharacteristics = [];
        for (let idCat of selectedFilterArticleCharacteristics) {

            let ct = allArticleCharacteristics.find(c => c.id == idCat);
            if (ct) {
                updatedArticleCharacteristics.push(ct);
            }
        }

        this.filterArticleCharacteristics.setSelectedItems(updatedArticleCharacteristics);

    }

    protected onClickAddSubContentArticle(): void {
        this.subContentArticles.onClickAdd();
    }

    public editSubContentArticle(article) {
        this.getTemplateViewModel().isSubContentArticlePopupVisible(true);
        this.getTemplateViewModel().subContentArticle(article);
    }

    public onCLickApplySubContentArticlePopup(): void {
        let subContentArticle = this.getTemplateViewModel().subContentArticle();
        subContentArticle['idArticle'] = this.subContentArticlesFilter.getTemplateViewModel().idArticle(),
        subContentArticle['reference'] = this.subContentArticlesFilter.getTemplateViewModel().articleObj().reference,
        subContentArticle['article'] = this.subContentArticlesFilter.getTemplateViewModel().articleObj(),
        this.subContentArticles.addSubContentArticle(subContentArticle);
        this.onCLickCloseSubContentArticlePopup();
    }

    public onCLickCloseSubContentArticlePopup(): void {
        this.subContentArticlesFilter.getTemplateViewModel().idArticle(null);
        this.subContentArticlesFilter.getTemplateViewModel().article("");
        this.subContentArticlesFilter.getTemplateViewModel().articleObj("");
        this.getTemplateViewModel().isSubContentArticlePopupVisible(false);
    }

    public getTotalPinnedHubPages(): number {
        let pinnedPrimary = this.pinnedListingPages.getListingPages();
        let pinnedSecondary = this.secondaryPinnedListingPages.getListingPages();

        return pinnedPrimary.length + pinnedSecondary.length;
    }

    public setLockPermalinkInput(lock: boolean) {
        this.getTemplateViewModel().lockPermalinkInput(lock)
    }
    public setLockRadioPermalinks(lock: boolean) {
        this.getTemplateViewModel().lockRadioPermalinks(lock);
    }

    public setLockRadioConfigType(lock: boolean) {
        this.getTemplateViewModel().lockRadioConfigType(lock);
    }

    public isOfConfigType(configType: string): boolean {
        return (this.getTemplateViewModel().listingPageConfigType() == configType);
    }

    public isHomePageHubPage(listingPageConfig) {
        return (listingPageConfig && (listingPageConfig == HubPageConfig.HOMEPAGE_VIDEO || listingPageConfig == HubPageConfig.HOMEPAGE_THREAD));
    }

    public filterLayoutOptions(): void {

        let listingPageConfigType = this.getTemplateViewModel().listingPageConfigType();
        let layoutOptions = this.getTemplateViewModel().layoutOptions();
        let selectedArticleType = this.articleTypeSelector.getSelectedOption();
        let selectedArticleTypeId = selectedArticleType ? selectedArticleType.id : null;
        let activeLayoutOptions = layoutOptions;
        let firstLayout = layoutOptions[0];
        if (listingPageConfigType != 'channel') {

            if (selectedArticleTypeId != 16) { // other than 16 = thread
                activeLayoutOptions = layoutOptions.filter(l => l.wrappingClass != 'featured-9-pin-autoscroll' && l.wrappingClass != 'featured-3-pin-autoplay');
            }
            if (selectedArticleTypeId != 15) { // 16 = thread
                activeLayoutOptions = layoutOptions.filter(l => l.wrappingClass != 'featured-3-pin-autoplay');
            }
        } else {
            activeLayoutOptions = layoutOptions.filter(l => l.wrappingClass == 'featured-3-pin-autoplay');
        }

        let idLayout = this.getTemplateViewModel().idLayout();

        let currentLayout = activeLayoutOptions.find(l => l.id == idLayout);

        if (!currentLayout) {
            this.getTemplateViewModel().idLayout(firstLayout ? firstLayout.id : null);
        }

        this.getTemplateViewModel().activeLayoutOptions(activeLayoutOptions);
    }

    public setChannelsSuggestions(channels) {
        this.channelFilter.setOptions(channels);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/listingPagesEdit_template.ts